// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod';

export const zApiError = z.object({
    code: z.enum([
        'name_taken',
        'already_exists',
        'copy_in_progress',
        'state_conflict',
        'last_owner',
        'last_active_operator',
        'operator_self_action',
        'sharing_version_conflict',
        'parent_trashed',
        'node_purged',
        'part_etag_conflict',
        'upload_verification_failed',
        'upload_file_mismatch',
        'upload_expired',
        'version_conflict',
        'precondition_failed',
        'upload_target_deleted',
        'own_file_exists',
        'replace_not_allowed',
        'admin_user_banned',
        'email_already_in_use',
        'organization_slug_taken',
        'idempotency_in_flight',
        'last_owner_of_nodes',
        'owner_protected',
        'org_link_on_personal_root',
        'org_link_inherited',
        'not_found',
        'insufficient_role',
        'purge_not_allowed',
        'cannot_grant_to_self',
        'org_link_disabled',
        'not_a_member',
        'admin_forbidden',
        'admin_organization_not_found',
        'admin_target_user_not_found',
        'app_version_too_old',
        'client_upgrade_required',
        'asset_not_found',
        'asset_ownership_error',
        'asset_variant_not_available',
        'auth_credentials_missing',
        'auth_csrf_invalid',
        'auth_jwt_invalid',
        'backoffice_admin_deleted',
        'backoffice_admin_disabled',
        'backoffice_auth_credentials_missing',
        'backoffice_csrf_invalid',
        'backoffice_jwt_invalid',
        'backoffice_oidc_callback_exchange_failed',
        'backoffice_oidc_callback_state_invalid',
        'backoffice_operator_not_provisioned',
        'backoffice_session_expired',
        'backoffice_session_invalid',
        'broadcast_recipients_not_found',
        'email_otp_token_invalid',
        'export_not_found',
        'openapi_not_found',
        'organization_login_unavailable',
        'otp_device_not_found',
        'organization_suspended',
        'invite_code_invalid',
        'invite_expired',
        'invite_already_used',
        'invite_organization_not_ready',
        'invite_organization_suspended',
        'session_expired',
        'session_invalid',
        'user_banned',
        'user_deleted',
        'oidc_native_code_invalid',
        'native_session_invalid',
        'storage_quota_exceeded',
        'quota_pool_exceeded',
        'quota_required',
        'rate_limited',
        'otp_issuance_throttled',
        'owner_not_assignable',
        'invalid_name',
        'max_depth_exceeded',
        'path_too_long',
        'parent_not_folder',
        'personal_folder_fixed_name',
        'personal_folder_cannot_move',
        'cycle_would_form',
        'cursor_invalid',
        'changes_cursor_expired',
        'validation_error',
        'admin_user_has_no_email',
        'asset_corrupted',
        'asset_mime_type_not_allowed',
        'asset_organization_not_allowed',
        'asset_organization_required',
        'asset_scope_invalid',
        'asset_size_too_large',
        'asset_storage_missing',
        'email_change_token_invalid',
        'export_too_large_for_sync',
        'unknown_policy_key',
        'policy_value_rejected',
        'link_not_allowed',
        'link_password_required',
        'link_expiry_out_of_range',
        'link_already_exists',
        'link_password_incorrect',
        'invalid_delete_account_otp',
        'new_email_same_as_current',
        'user_not_found',
        'oidc_callback_state_invalid',
        'oidc_callback_exchange_failed',
        'invite_password_rejected',
        'idempotency_key_required',
        'idempotency_key_reused',
        'node_not_a_file',
        'object_too_large',
        'copy_too_large',
        'invalid_checksum',
        'internal_error',
        'missing_org_context',
        'asset_variant_generation_failed',
        'maintenance_mode',
        'maintenance',
        'not_implemented',
        'social_provider_not_configured',
        'invite_activation_failed',
        'invite_identity_update_failed',
        'invite_delivery_not_queued',
        'storage_bucket_unresolved',
        'identity_provider_unavailable',
        'instance_storage_unavailable'
    ]),
    category: z.enum([
        'conflict',
        'denied',
        'quota',
        'fault',
        'invalid'
    ]),
    message: z.string(),
    details: z.optional(z.object({
        suggestedName: z.optional(z.string()),
        reason: z.optional(z.string()),
        restartFromFirstPage: z.optional(z.boolean()),
        limit: z.optional(z.number()),
        attempted: z.optional(z.number()),
        required: z.optional(z.string()),
        effective: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        scope: z.optional(z.enum(['person', 'organization'])),
        limitBytes: z.optional(z.number()),
        usedBytes: z.optional(z.number()),
        totalBytes: z.optional(z.number()),
        availableBytes: z.optional(z.number()),
        retryAfterSeconds: z.optional(z.number()),
        platform: z.optional(z.string()),
        minimumVersion: z.optional(z.string()),
        latestVersion: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        notice: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        until: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        bounds: z.optional(z.union([
            z.object({
                min: z.optional(z.number()),
                max: z.optional(z.number())
            }),
            z.null()
        ])),
        violated: z.optional(z.enum(['min', 'max'])),
        nodeIds: z.optional(z.array(z.string())),
        rowCount: z.optional(z.number()),
        expectedVersion: z.optional(z.number()),
        currentVersion: z.optional(z.number()),
        changedBy: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        changedAt: z.optional(z.string()),
        node: z.optional(z.record(z.string(), z.unknown())),
        nodeId: z.optional(z.string()),
        ownerId: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        ownerName: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        createdByOthers: z.optional(z.number()),
        originalParentId: z.optional(z.string()),
        trashedAt: z.optional(z.string()),
        trashedBy: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        canRestore: z.optional(z.boolean()),
        stage: z.optional(z.string())
    })),
    requestId: z.optional(z.string()),
    timestamp: z.optional(z.string())
});

export const zAppConfigStatus = z.object({
    status: z.enum([
        'ok',
        'force_update',
        'maintenance'
    ]),
    minVersionIos: z.string(),
    minVersionAndroid: z.string(),
    naming: z.object({
        maxNodeNameBytes: z.int().gte(-9007199254740991).lte(9007199254740991),
        maxDrivePathLength: z.int().gte(-9007199254740991).lte(9007199254740991)
    }),
    presignedUrls: z.object({
        downloadTtlSeconds: z.int().gte(-9007199254740991).lte(9007199254740991),
        uploadTtlSeconds: z.int().gte(-9007199254740991).lte(9007199254740991)
    }),
    uploads: z.object({
        resumeWindowDays: z.int().gte(-9007199254740991).lte(9007199254740991)
    }),
    maintenance: z.union([
        z.object({
            enabled: z.boolean(),
            message: z.union([
                z.string(),
                z.null()
            ]),
            retryAfterSeconds: z.union([
                z.int().gte(-9007199254740991).lte(9007199254740991),
                z.null()
            ])
        }),
        z.null()
    ])
});

export const zClientPlatformVersions = z.object({
    minimumVersion: z.union([
        z.string(),
        z.null()
    ]),
    latestVersion: z.union([
        z.string(),
        z.null()
    ])
});

export const zClientMaintenance = z.object({
    active: z.boolean(),
    message: z.union([
        z.string(),
        z.null()
    ]),
    until: z.union([
        z.string(),
        z.null()
    ])
});

export const zClientPolicy = z.object({
    platforms: z.object({
        ios: zClientPlatformVersions,
        macos: zClientPlatformVersions,
        windows: zClientPlatformVersions,
        android: zClientPlatformVersions
    }),
    maintenance: zClientMaintenance
});

export const zInstantOutput = z.string();

export const zLoginBrandingImageRef = z.object({
    url: z.string()
});

export const zLoginBrandingFontId = z.enum([
    'google-sans',
    'inter',
    'roboto',
    'source-sans-3'
]);

export const zLoginBrandingInstance = z.object({
    productName: z.optional(z.string()),
    texts: z.object({
        copyright: z.optional(z.object({
            it: z.string().min(1).max(160),
            en: z.string().min(1).max(160)
        }))
    }).default({}),
    images: z.object({
        logo: z.optional(zLoginBrandingImageRef),
        logoDark: z.optional(zLoginBrandingImageRef),
        mark: z.optional(zLoginBrandingImageRef),
        markDark: z.optional(zLoginBrandingImageRef),
        favicon: z.optional(zLoginBrandingImageRef),
        background: z.optional(zLoginBrandingImageRef),
        backgroundDark: z.optional(zLoginBrandingImageRef)
    }).default({}),
    tokens: z.object({
        light: z.record(z.string(), z.string()),
        dark: z.record(z.string(), z.string())
    }),
    font: z.optional(zLoginBrandingFontId),
    desktopClientUrl: z.optional(z.string()),
    allowUncappedQuotas: z.optional(z.boolean())
});

export const zPresignedPutUpload = z.object({
    method: z.enum(['PUT']),
    url: z.string(),
    headers: z.record(z.string(), z.string())
});

export const zPresignedPostUpload = z.object({
    method: z.enum(['POST']),
    url: z.string(),
    fields: z.record(z.string(), z.string())
});

export const zPresignedUpload = z.union([
    z.object({
        method: z.literal('PUT')
    }).and(zPresignedPutUpload),
    z.object({
        method: z.literal('POST')
    }).and(zPresignedPostUpload)
]);

export const zCreatedAsset = z.object({
    id: z.string(),
    upload: zPresignedUpload
});

export const zGetSessionSessionBlock = z.object({
    expiresAt: zInstantOutput,
    lastActivityAt: zInstantOutput,
    creationSource: z.string()
});

export const zAuthIdentity = z.object({
    id: z.string(),
    isAnonymous: z.boolean()
});

export const zOrganizationSummary = z.object({
    id: z.string(),
    name: z.string(),
    slug: z.string()
});

export const zSessionLocation = z.object({
    street: z.union([
        z.string(),
        z.null()
    ]),
    city: z.union([
        z.string(),
        z.null()
    ]),
    country: z.union([
        z.string(),
        z.null()
    ]),
    countryCode: z.union([
        z.string(),
        z.null()
    ])
});

export const zSessionDeviceBrowser = z.object({
    name: z.union([
        z.string(),
        z.null()
    ]),
    version: z.union([
        z.string(),
        z.null()
    ])
});

export const zSessionDeviceOs = z.object({
    name: z.union([
        z.string(),
        z.null()
    ]),
    version: z.union([
        z.string(),
        z.null()
    ])
});

export const zSessionDeviceInfo = z.object({
    type: z.union([
        z.string(),
        z.null()
    ]),
    model: z.union([
        z.string(),
        z.null()
    ]),
    vendor: z.union([
        z.string(),
        z.null()
    ])
});

export const zSessionDeviceEngine = z.object({
    name: z.union([
        z.string(),
        z.null()
    ]),
    version: z.union([
        z.string(),
        z.null()
    ])
});

export const zSessionListItem = z.object({
    id: z.string(),
    ipAddress: z.union([
        z.string(),
        z.null()
    ]),
    userAgent: z.union([
        z.string(),
        z.null()
    ]),
    location: z.union([
        z.object({
            street: z.union([
                z.string(),
                z.null()
            ]),
            city: z.union([
                z.string(),
                z.null()
            ]),
            country: z.union([
                z.string(),
                z.null()
            ]),
            countryCode: z.union([
                z.string(),
                z.null()
            ])
        }),
        z.null()
    ]),
    device: z.union([
        z.object({
            browser: zSessionDeviceBrowser,
            os: zSessionDeviceOs,
            device: zSessionDeviceInfo,
            engine: zSessionDeviceEngine
        }),
        z.null()
    ]),
    creationSource: z.enum([
        'password',
        'oauth',
        'passkey',
        'magic_link',
        'email_otp',
        'password_reset',
        'anonymous',
        'oidc'
    ]),
    rememberMe: z.boolean(),
    status: z.enum([
        'active',
        'revoked',
        'expired'
    ]),
    isCurrent: z.boolean(),
    createdAt: zInstantOutput,
    lastActivityAt: zInstantOutput,
    expiresAt: zInstantOutput,
    revokedAt: z.union([
        z.string(),
        z.null()
    ]),
    native: z.union([
        z.object({
            platform: z.enum([
                'ios',
                'android',
                'macos',
                'windows'
            ]),
            model: z.string().min(1).max(128),
            systemName: z.string().min(1).max(128),
            systemVersion: z.string().min(1).max(128),
            appVersion: z.string().min(1).max(128)
        }),
        z.null()
    ])
});

export const zSessionDevice = z.object({
    browser: zSessionDeviceBrowser,
    os: zSessionDeviceOs,
    device: zSessionDeviceInfo,
    engine: zSessionDeviceEngine
});

export const zSessionNative = z.object({
    platform: z.enum([
        'ios',
        'android',
        'macos',
        'windows'
    ]),
    model: z.string().min(1).max(128),
    systemName: z.string().min(1).max(128),
    systemVersion: z.string().min(1).max(128),
    appVersion: z.string().min(1).max(128)
});

export const zOffsetPaginationMeta = z.object({
    page: z.number(),
    limit: z.number(),
    total: z.number(),
    totalPages: z.number()
});

export const zRevokeSessionsData = z.object({
    sessionsRevoked: z.int().gte(0).lte(9007199254740991),
    residualWindowSeconds: z.int().gt(0).lte(9007199254740991),
    channel: z.enum(['closed', 'pending']),
    channelWindowSeconds: z.optional(z.int().gt(0).lte(9007199254740991))
});

export const zStatusSuccessResponse = z.object({
    status: z.enum(['success'])
});

export const zDeleteAccountRequiresOtp = z.object({
    status: z.enum(['requires_otp']),
    emailOtpToken: z.string()
});

export const zNativeDevice = z.object({
    model: z.string().min(1).max(128),
    systemName: z.string().min(1).max(128),
    systemVersion: z.string().min(1).max(128),
    appVersion: z.string().min(1).max(128)
});

export const zNativeSession = z.object({
    sessionId: z.string(),
    accessToken: z.string(),
    accessTokenExpiresAt: zInstantOutput,
    refreshToken: z.string()
});

export const zPasswordPolicyRule = z.object({
    id: z.string(),
    value: z.union([
        z.string(),
        z.null()
    ])
});

export const zPasswordPolicy = z.object({
    raw: z.string(),
    rules: z.array(zPasswordPolicyRule)
});

export const zInvitation = z.object({
    organizationName: z.string(),
    organizationSlug: z.string(),
    email: z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
    role: z.enum(['org_admin', 'member']),
    locale: z.string(),
    expiresAt: zInstantOutput,
    passwordPolicy: zPasswordPolicy
});

export const zInstant = z.string();

export const zAuditEvent = z.object({
    entry: z.enum(['event']),
    id: z.string(),
    createdAt: zInstantOutput,
    actorKind: z.enum([
        'user',
        'operator',
        'system',
        'device',
        'link_recipient'
    ]),
    actorId: z.union([
        z.string(),
        z.null()
    ]),
    action: z.enum([
        'authz.denied',
        'policy.changed',
        'audit.retention_applied',
        'share.granted',
        'share.role_changed',
        'share.revoked',
        'group.created',
        'group.updated',
        'group.deleted',
        'group.member_added',
        'group.member_removed',
        'node.purged',
        'node.version_deleted',
        'node.versions_expired',
        'upload.expired',
        'node.upload_reconciled',
        'user.invited',
        'user.invite_accepted',
        'user.invite_resent',
        'user.removed',
        'user.email_changed',
        'user.deactivated',
        'user.reactivated',
        'user.membership_removed',
        'user.role_changed',
        'user.owner_granted',
        'user.quota_changed',
        'user.owner_revoked',
        'session.revoked',
        'session.force_disconnected',
        'user.credentials_changed',
        'organization.created',
        'organization.suspended',
        'organization.reactivated',
        'organization.quota_changed',
        'organization.version_retention_changed',
        'organization.storage_destroyed',
        'link.created',
        'link.updated',
        'link.revoked',
        'link.accessed',
        'link.previewed',
        'link.downloaded',
        'link.password_locked',
        'link.upload_limited',
        'org_link.changed',
        'org_link.opened'
    ]),
    objectType: z.string(),
    objectId: z.string(),
    outcome: z.enum(['success', 'failure']),
    origin: z.enum([
        'web',
        'api',
        'system'
    ]),
    actorName: z.union([
        z.string(),
        z.null()
    ]),
    actorEmail: z.union([
        z.string(),
        z.null()
    ]),
    objectName: z.union([
        z.string(),
        z.null()
    ]),
    subjectName: z.union([
        z.string(),
        z.null()
    ]),
    userAgent: z.union([
        z.string(),
        z.null()
    ]),
    metadata: z.union([
        z.record(z.string(), z.unknown()),
        z.null()
    ])
});

export const zAuditBatch = z.object({
    entry: z.enum(['batch']),
    id: z.string(),
    kind: z.enum([
        'upload',
        'download',
        'preview',
        'trash',
        'restore',
        'version_restore',
        'copy'
    ]),
    actorKind: z.enum([
        'user',
        'operator',
        'system',
        'device',
        'link_recipient'
    ]),
    actorId: z.union([
        z.string(),
        z.null()
    ]),
    actorName: z.union([
        z.string(),
        z.null()
    ]),
    actorEmail: z.union([
        z.string(),
        z.null()
    ]),
    origin: z.enum([
        'web',
        'api',
        'system'
    ]),
    userAgent: z.union([
        z.string(),
        z.null()
    ]),
    filesSucceeded: z.number(),
    filesFailed: z.number(),
    bytes: z.number(),
    firstAt: zInstantOutput,
    lastAt: zInstantOutput,
    batchId: z.string()
});

export const zAuditTimelineEntry = z.union([
    z.object({
        entry: z.literal('event')
    }).and(zAuditEvent),
    z.object({
        entry: z.literal('batch')
    }).and(zAuditBatch)
]);

export const zAuditRetention = z.object({
    days: z.number(),
    cutoff: zInstantOutput,
    requestedRange: z.nullable(z.enum([
        'within',
        'partly_beyond',
        'entirely_beyond'
    ]))
});

export const zAuditPerson = z.object({
    name: z.union([
        z.string(),
        z.null()
    ])
});

export const zUser = z.object({
    id: z.string(),
    name: z.string(),
    email: z.union([
        z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
        z.null()
    ]),
    image: z.optional(z.union([
        z.object({
            url: z.string(),
            blurhash: z.union([
                z.string(),
                z.null()
            ]),
            width: z.union([
                z.int().gte(-9007199254740991).lte(9007199254740991),
                z.null()
            ]),
            height: z.union([
                z.int().gte(-9007199254740991).lte(9007199254740991),
                z.null()
            ]),
            variants: z.union([
                z.object({
                    original: z.optional(z.string()),
                    thumbnail: z.optional(z.string()),
                    small: z.optional(z.string()),
                    medium: z.optional(z.string()),
                    large: z.optional(z.string())
                }),
                z.null()
            ])
        }),
        z.null()
    ])),
    hasPassword: z.boolean(),
    emailStatus: z.enum([
        'none',
        'unverified',
        'verified'
    ]),
    personalFolderId: z.union([
        z.string(),
        z.null()
    ]),
    createdAt: zInstantOutput
});

export const zImagePayload = z.object({
    url: z.string(),
    blurhash: z.union([
        z.string(),
        z.null()
    ]),
    width: z.union([
        z.int().gte(-9007199254740991).lte(9007199254740991),
        z.null()
    ]),
    height: z.union([
        z.int().gte(-9007199254740991).lte(9007199254740991),
        z.null()
    ]),
    variants: z.union([
        z.object({
            original: z.optional(z.string()),
            thumbnail: z.optional(z.string()),
            small: z.optional(z.string()),
            medium: z.optional(z.string()),
            large: z.optional(z.string())
        }),
        z.null()
    ])
});

export const zImageVariants = z.object({
    original: z.optional(z.string()),
    thumbnail: z.optional(z.string()),
    small: z.optional(z.string()),
    medium: z.optional(z.string()),
    large: z.optional(z.string())
});

export const zUserPreferencesData = z.object({
    language: z.enum(['en', 'it']),
    theme: z.enum([
        'light',
        'dark',
        'system'
    ]),
    completedTutorials: z.array(z.string()),
    tutorialsDismissed: z.boolean()
});

export const zOtpDevice = z.object({
    id: z.string(),
    label: z.union([
        z.string(),
        z.null()
    ]),
    createdAt: z.union([
        z.string(),
        z.null()
    ])
});

export const zAccountSecurity = z.object({
    password: z.object({
        lastChangedAt: z.union([
            z.string(),
            z.null()
        ])
    }),
    mfa: z.object({
        enabled: z.boolean(),
        configuredAt: z.union([
            z.string(),
            z.null()
        ]),
        devices: z.array(zOtpDevice),
        recoveryCodes: z.union([
            z.object({
                remaining: z.int().gte(-9007199254740991).lte(9007199254740991)
            }),
            z.null()
        ])
    })
});

export const zPersonStorage = z.object({
    quotaBytes: z.union([
        z.int().gte(0).lte(9007199254740991),
        z.null()
    ]),
    usedBytes: z.int().gte(0).lte(9007199254740991),
    availableBytes: z.union([
        z.int().gte(0).lte(9007199254740991),
        z.null()
    ])
});

export const zUserSearchResult = z.object({
    id: z.string(),
    name: z.string(),
    image: z.union([
        z.object({
            url: z.string(),
            blurhash: z.union([
                z.string(),
                z.null()
            ]),
            width: z.union([
                z.int().gte(-9007199254740991).lte(9007199254740991),
                z.null()
            ]),
            height: z.union([
                z.int().gte(-9007199254740991).lte(9007199254740991),
                z.null()
            ]),
            variants: z.union([
                z.object({
                    original: z.optional(z.string()),
                    thumbnail: z.optional(z.string()),
                    small: z.optional(z.string()),
                    medium: z.optional(z.string()),
                    large: z.optional(z.string())
                }),
                z.null()
            ])
        }),
        z.null()
    ]),
    email: z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/)
});

export const zCursorPaginationMeta = z.object({
    total: z.number(),
    nextCursor: z.union([
        z.string(),
        z.null()
    ])
});

export const zLink = z.object({
    id: z.string(),
    nodeId: z.string(),
    nodeName: z.string(),
    kind: z.enum(['download', 'upload']),
    token: z.string(),
    state: z.enum([
        'active',
        'expired',
        'revoked',
        'policy_blocked'
    ]),
    hasPassword: z.boolean(),
    expiresAt: z.union([
        z.string(),
        z.null()
    ]),
    description: z.union([
        z.string(),
        z.null()
    ]),
    accessCount: z.int().gte(-9007199254740991).lte(9007199254740991),
    createdAt: zInstantOutput,
    revokedAt: z.union([
        z.string(),
        z.null()
    ])
});

export const zNodeLinkCreator = z.object({
    id: z.string(),
    name: z.union([
        z.string(),
        z.null()
    ])
});

export const zNodeLinks = z.object({
    own: z.union([
        z.object({
            id: z.string(),
            nodeId: z.string(),
            nodeName: z.string(),
            kind: z.enum(['download', 'upload']),
            token: z.string(),
            state: z.enum([
                'active',
                'expired',
                'revoked',
                'policy_blocked'
            ]),
            hasPassword: z.boolean(),
            expiresAt: z.union([
                z.string(),
                z.null()
            ]),
            description: z.union([
                z.string(),
                z.null()
            ]),
            accessCount: z.int().gte(-9007199254740991).lte(9007199254740991),
            createdAt: zInstantOutput,
            revokedAt: z.union([
                z.string(),
                z.null()
            ])
        }),
        z.null()
    ]),
    others: z.object({
        count: z.int().gte(-9007199254740991).lte(9007199254740991),
        creators: z.array(zNodeLinkCreator)
    })
});

export const zAdminLink = z.object({
    id: z.string(),
    nodeId: z.string(),
    resourceName: z.string(),
    kind: z.enum(['download', 'upload']),
    creatorId: z.string(),
    creatorName: z.union([
        z.string(),
        z.null()
    ]),
    state: z.enum([
        'active',
        'expired',
        'revoked',
        'policy_blocked'
    ]),
    hasPassword: z.boolean(),
    expiresAt: z.union([
        z.string(),
        z.null()
    ]),
    description: z.union([
        z.string(),
        z.null()
    ]),
    accessCount: z.int().gte(-9007199254740991).lte(9007199254740991),
    createdAt: zInstantOutput
});

export const zNotification = z.object({
    id: z.string(),
    userId: z.string(),
    type: z.enum(['banner', 'announcement']),
    vars: z.record(z.string(), z.unknown()),
    action: z.union([
        z.object({
            resource: z.string().min(1).max(64).regex(/^[a-z][a-z0-9_]*$/),
            resourceId: z.string().min(1).max(256)
        }),
        z.null()
    ]),
    seenAt: z.union([
        z.string(),
        z.null()
    ]),
    readAt: z.union([
        z.string(),
        z.null()
    ]),
    createdAt: zInstantOutput
});

export const zNotificationAction = z.object({
    resource: z.string().min(1).max(64).regex(/^[a-z][a-z0-9_]*$/),
    resourceId: z.string().min(1).max(256)
});

export const zMarkNotificationsRead = z.object({
    ids: z.array(z.string()).min(1).max(100),
    read: z.literal(true)
});

export const zMarkAllNotificationsRead = z.object({
    scope: z.enum(['all']),
    read: z.literal(true)
});

export const zMarkAllNotificationsSeen = z.object({
    scope: z.enum(['all']),
    seen: z.literal(true)
});

export const zNotificationConnectionTokenData = z.object({
    token: z.string(),
    subscriptionToken: z.string(),
    channel: z.string(),
    wsUrl: z.string()
});

export const zDirectoryConnectionTokenData = z.object({
    token: z.string(),
    subscriptionToken: z.string(),
    channel: z.string(),
    wsUrl: z.string(),
    recoveryWindowSeconds: z.int().gt(0).lte(9007199254740991)
});

export const zNotificationChannelPref = z.object({
    push: z.boolean()
});

export const zResolvedNotificationPreferences = z.object({
    announcement: zNotificationChannelPref
});

export const zNotificationChannelPatch = z.object({
    push: z.optional(z.boolean())
});

export const zUpdateNotificationPreferences = z.object({
    announcement: z.optional(zNotificationChannelPatch)
});

export const zOrganizationPerson = z.object({
    id: z.string(),
    name: z.union([
        z.string(),
        z.null()
    ]),
    email: z.union([
        z.string(),
        z.null()
    ]),
    role: z.nullable(z.enum(['org_admin', 'member'])),
    status: z.enum([
        'active',
        'invited',
        'deactivated',
        'removed'
    ]),
    lastActivityAt: z.union([
        z.string(),
        z.null()
    ]),
    inviteId: z.union([
        z.string(),
        z.null()
    ]),
    invitedAt: z.union([
        z.string(),
        z.null()
    ]),
    invitationExpiresAt: z.union([
        z.string(),
        z.null()
    ]),
    createdAt: zInstantOutput,
    isOwner: z.boolean(),
    quotaBytes: z.union([
        z.int().gte(0).lte(9007199254740991),
        z.null()
    ]),
    usedBytes: z.int().gte(0).lte(9007199254740991)
});

export const zOrganizationSessionListItem = z.object({
    id: z.string(),
    ipAddress: z.union([
        z.string(),
        z.null()
    ]),
    userAgent: z.union([
        z.string(),
        z.null()
    ]),
    location: z.union([
        z.object({
            street: z.union([
                z.string(),
                z.null()
            ]),
            city: z.union([
                z.string(),
                z.null()
            ]),
            country: z.union([
                z.string(),
                z.null()
            ]),
            countryCode: z.union([
                z.string(),
                z.null()
            ])
        }),
        z.null()
    ]),
    device: z.union([
        z.object({
            browser: zSessionDeviceBrowser,
            os: zSessionDeviceOs,
            device: zSessionDeviceInfo,
            engine: zSessionDeviceEngine
        }),
        z.null()
    ]),
    creationSource: z.enum([
        'password',
        'oauth',
        'passkey',
        'magic_link',
        'email_otp',
        'password_reset',
        'anonymous',
        'oidc'
    ]),
    rememberMe: z.boolean(),
    status: z.enum([
        'active',
        'revoked',
        'expired'
    ]),
    isCurrent: z.boolean(),
    createdAt: zInstantOutput,
    lastActivityAt: zInstantOutput,
    expiresAt: zInstantOutput,
    revokedAt: z.union([
        z.string(),
        z.null()
    ]),
    native: z.union([
        z.object({
            platform: z.enum([
                'ios',
                'android',
                'macos',
                'windows'
            ]),
            model: z.string().min(1).max(128),
            systemName: z.string().min(1).max(128),
            systemVersion: z.string().min(1).max(128),
            appVersion: z.string().min(1).max(128)
        }),
        z.null()
    ]),
    userId: z.string(),
    userName: z.union([
        z.string(),
        z.null()
    ]),
    userEmail: z.union([
        z.string(),
        z.null()
    ]),
    channel: z.enum([
        'connected',
        'disconnected',
        'unknown'
    ])
});

export const zOrganizationInvitation = z.object({
    id: z.string(),
    email: z.string(),
    role: z.enum(['org_admin', 'member']),
    status: z.enum([
        'pending',
        'accepted',
        'expired',
        'revoked'
    ]),
    expiresAt: zInstantOutput,
    createdAt: zInstantOutput
});

export const zInvitationSent = z.object({
    status: z.enum(['success']),
    invitation: zOrganizationInvitation
});

export const zInvitationRequiresDeactivation = z.object({
    status: z.enum(['requires_deactivation']),
    userId: z.string()
});

export const zInvitationRevoked = z.object({
    status: z.enum(['success']),
    userId: z.string(),
    grantsRemoved: z.number()
});

export const zOrganizationQuota = z.object({
    quotaBytes: z.union([
        z.int().gte(0).lte(9007199254740991),
        z.null()
    ]),
    assignedBytes: z.int().gte(0).lte(9007199254740991),
    usedBytes: z.int().gte(0).lte(9007199254740991)
});

export const zPersonQuota = z.object({
    userId: z.string(),
    quotaBytes: z.union([
        z.int().gte(0).lte(9007199254740991),
        z.null()
    ]),
    usedBytes: z.int().gte(0).lte(9007199254740991)
});

export const zVersionRetention = z.object({
    keepVersions: z.union([
        z.int().gte(1).lte(1000),
        z.null()
    ]),
    keepDays: z.union([
        z.int().gte(1).lte(3650),
        z.null()
    ])
});

export const zPolicySetting = z.object({
    key: z.string(),
    describe: z.string(),
    value: z.unknown(),
    fallback: z.unknown(),
    isOverridden: z.boolean(),
    bounds: z.union([
        z.object({
            min: z.optional(z.number()),
            max: z.optional(z.number())
        }),
        z.null()
    ])
});

export const zGroup = z.object({
    id: z.string(),
    name: z.string(),
    visibility: z.enum(['public', 'private']),
    memberCount: z.int().gte(-9007199254740991).lte(9007199254740991),
    isMember: z.boolean(),
    canManage: z.boolean(),
    createdAt: zInstantOutput,
    updatedAt: zInstantOutput
});

export const zGroupDetail = z.object({
    id: z.string(),
    name: z.string(),
    visibility: z.enum(['public', 'private']),
    memberCount: z.int().gte(-9007199254740991).lte(9007199254740991),
    isMember: z.boolean(),
    canManage: z.boolean(),
    createdAt: zInstantOutput,
    updatedAt: zInstantOutput,
    shareCount: z.union([
        z.int().gte(-9007199254740991).lte(9007199254740991),
        z.null()
    ])
});

export const zGroupCandidate = z.object({
    id: z.string(),
    name: z.string(),
    image: z.union([
        z.object({
            url: z.string(),
            blurhash: z.union([
                z.string(),
                z.null()
            ]),
            width: z.union([
                z.int().gte(-9007199254740991).lte(9007199254740991),
                z.null()
            ]),
            height: z.union([
                z.int().gte(-9007199254740991).lte(9007199254740991),
                z.null()
            ]),
            variants: z.union([
                z.object({
                    original: z.optional(z.string()),
                    thumbnail: z.optional(z.string()),
                    small: z.optional(z.string()),
                    medium: z.optional(z.string()),
                    large: z.optional(z.string())
                }),
                z.null()
            ])
        }),
        z.null()
    ]),
    email: z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
    isMember: z.boolean()
});

export const zAdminUserListItem = z.object({
    id: z.string(),
    name: z.string(),
    email: z.union([
        z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
        z.null()
    ]),
    status: z.enum([
        'active',
        'banned',
        'deleted'
    ]),
    image: z.optional(z.union([
        z.object({
            url: z.string(),
            blurhash: z.union([
                z.string(),
                z.null()
            ]),
            width: z.union([
                z.int().gte(-9007199254740991).lte(9007199254740991),
                z.null()
            ]),
            height: z.union([
                z.int().gte(-9007199254740991).lte(9007199254740991),
                z.null()
            ]),
            variants: z.union([
                z.object({
                    original: z.optional(z.string()),
                    thumbnail: z.optional(z.string()),
                    small: z.optional(z.string()),
                    medium: z.optional(z.string()),
                    large: z.optional(z.string())
                }),
                z.null()
            ])
        }),
        z.null()
    ])),
    emailVerified: z.boolean(),
    emailVerifiedAt: z.union([
        z.string(),
        z.null()
    ]),
    banned: z.boolean(),
    banReason: z.union([
        z.string(),
        z.null()
    ]),
    banExpires: z.union([
        z.string(),
        z.null()
    ]),
    signupSource: z.enum([
        'email',
        'google',
        'apple',
        'x',
        'passkey',
        'anonymous',
        'oidc'
    ]),
    createdAt: zInstantOutput,
    role: z.nullable(z.enum(['org_admin', 'member'])),
    isOwner: z.boolean()
});

export const zInstantRange = z.object({
    from: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    to: z.optional(z.union([
        z.string(),
        z.null()
    ]))
});

export const zAdminUserPushRegistrations = z.object({
    pushDevicesCount: z.int().gte(-9007199254740991).lte(9007199254740991)
});

export const zAdminUserSessionItem = z.object({
    id: z.string(),
    ipAddress: z.union([
        z.string(),
        z.null()
    ]),
    userAgent: z.union([
        z.string(),
        z.null()
    ]),
    location: z.union([
        z.object({
            street: z.union([
                z.string(),
                z.null()
            ]),
            city: z.union([
                z.string(),
                z.null()
            ]),
            country: z.union([
                z.string(),
                z.null()
            ]),
            countryCode: z.union([
                z.string(),
                z.null()
            ])
        }),
        z.null()
    ]),
    device: z.union([
        z.object({
            browser: zSessionDeviceBrowser,
            os: zSessionDeviceOs,
            device: zSessionDeviceInfo,
            engine: zSessionDeviceEngine
        }),
        z.null()
    ]),
    creationSource: z.enum([
        'password',
        'oauth',
        'passkey',
        'magic_link',
        'email_otp',
        'password_reset',
        'anonymous',
        'oidc'
    ]),
    rememberMe: z.boolean(),
    status: z.enum([
        'active',
        'revoked',
        'expired'
    ]),
    createdAt: zInstantOutput,
    lastActivityAt: zInstantOutput,
    expiresAt: zInstantOutput,
    revokedAt: z.union([
        z.string(),
        z.null()
    ])
});

export const zAdminBroadcastableNotificationType = z.enum(['announcement']);

export const zBroadcastChannels = z.object({
    push: z.boolean()
});

export const zNotificationBroadcast = z.object({
    id: z.string(),
    title: z.string(),
    body: z.string(),
    type: z.enum(['banner', 'announcement']),
    channels: zBroadcastChannels,
    targetType: z.enum(['all', 'selected']),
    status: z.enum([
        'pending',
        'sending',
        'sent',
        'failed'
    ]),
    recipientCount: z.number(),
    seenCount: z.number(),
    readCount: z.number(),
    createdByAdminId: z.union([
        z.string(),
        z.null()
    ]),
    sentAt: z.union([
        z.string(),
        z.null()
    ]),
    createdAt: zInstantOutput
});

export const zBroadcastRecipient = z.object({
    userId: z.string(),
    name: z.string(),
    seenAt: z.union([
        z.string(),
        z.null()
    ]),
    readAt: z.union([
        z.string(),
        z.null()
    ]),
    createdAt: zInstantOutput
});

export const zOrganization = z.object({
    id: z.string(),
    slug: z.string().min(3).max(64).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
    name: z.string(),
    status: z.enum([
        'pending',
        'identity_ready',
        'storage_ready',
        'admin_invited',
        'ready',
        'failed',
        'suspended',
        'purging',
        'purged'
    ]),
    failedStep: z.nullable(z.enum([
        'identity',
        'storage',
        'admin_invite'
    ])),
    failureCode: z.union([
        z.string(),
        z.null()
    ]),
    failureDetail: z.union([
        z.string(),
        z.null()
    ]),
    provisioningAttempts: z.int().gte(-9007199254740991).lte(9007199254740991),
    provisioningLastAttemptAt: z.union([
        z.string(),
        z.null()
    ]),
    usageBytes: z.union([
        z.number(),
        z.null()
    ]),
    usageMeasuredAt: z.union([
        z.string(),
        z.null()
    ]),
    usageLastOutcome: z.nullable(z.enum([
        'measured',
        'failed',
        'not_applicable'
    ])),
    purgeStartedAt: z.union([
        z.string(),
        z.null()
    ]),
    purgedObjectVersions: z.int().gte(-9007199254740991).lte(9007199254740991),
    purgedNodes: z.int().gte(-9007199254740991).lte(9007199254740991),
    createdAt: zInstantOutput,
    updatedAt: zInstantOutput
});

export const zOrganizationListItem = z.object({
    id: z.string(),
    name: z.string(),
    status: z.enum([
        'pending',
        'identity_ready',
        'storage_ready',
        'admin_invited',
        'ready',
        'failed',
        'suspended',
        'purging',
        'purged'
    ]),
    usageBytes: z.union([
        z.number(),
        z.null()
    ]),
    usageMeasuredAt: z.union([
        z.string(),
        z.null()
    ]),
    usageLastOutcome: z.nullable(z.enum([
        'measured',
        'failed',
        'not_applicable'
    ])),
    createdAt: zInstantOutput,
    quotaBytes: z.union([
        z.int().gte(0).lte(9007199254740991),
        z.null()
    ]),
    activeUserCount: z.int().gte(-9007199254740991).lte(9007199254740991)
});

export const zOrganizationDetail = z.object({
    id: z.string(),
    slug: z.string().min(3).max(64).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
    name: z.string(),
    status: z.enum([
        'pending',
        'identity_ready',
        'storage_ready',
        'admin_invited',
        'ready',
        'failed',
        'suspended',
        'purging',
        'purged'
    ]),
    failedStep: z.nullable(z.enum([
        'identity',
        'storage',
        'admin_invite'
    ])),
    failureCode: z.union([
        z.string(),
        z.null()
    ]),
    failureDetail: z.union([
        z.string(),
        z.null()
    ]),
    provisioningAttempts: z.int().gte(-9007199254740991).lte(9007199254740991),
    provisioningLastAttemptAt: z.union([
        z.string(),
        z.null()
    ]),
    usageBytes: z.union([
        z.number(),
        z.null()
    ]),
    usageMeasuredAt: z.union([
        z.string(),
        z.null()
    ]),
    usageLastOutcome: z.nullable(z.enum([
        'measured',
        'failed',
        'not_applicable'
    ])),
    purgeStartedAt: z.union([
        z.string(),
        z.null()
    ]),
    purgedObjectVersions: z.int().gte(-9007199254740991).lte(9007199254740991),
    purgedNodes: z.int().gte(-9007199254740991).lte(9007199254740991),
    createdAt: zInstantOutput,
    updatedAt: zInstantOutput,
    quotaBytes: z.union([
        z.int().gte(0).lte(9007199254740991),
        z.null()
    ]),
    quotaAssignedBytes: z.int().gte(0).lte(9007199254740991),
    quotaUsedBytes: z.int().gte(0).lte(9007199254740991)
});

export const zRetryProvisioningQueued = z.object({
    status: z.enum(['queued']),
    data: zOrganization
});

export const zRetryProvisioningAlreadyInProgress = z.object({
    status: z.enum(['already_in_progress']),
    data: zOrganization
});

export const zRetryProvisioningRequiresAdminEmail = z.object({
    status: z.enum(['requires_admin_email'])
});

export const zPurgeOrganizationQueued = z.object({
    status: z.enum(['queued']),
    data: zOrganization
});

export const zPurgeOrganizationAlreadyInProgress = z.object({
    status: z.enum(['already_in_progress']),
    data: zOrganization
});

export const zPurgeOrganizationAlreadyPurged = z.object({
    status: z.enum(['already_purged']),
    data: zOrganization
});

export const zFirstAdminInvitation = z.object({
    email: z.string(),
    status: z.enum([
        'pending',
        'accepted',
        'expired',
        'revoked'
    ]),
    expiresAt: zInstantOutput,
    createdAt: zInstantOutput,
    resendCount: z.int().gte(-9007199254740991).lte(9007199254740991)
});

export const zOperatorAuditEvent = z.object({
    id: z.string(),
    createdAt: zInstantOutput,
    action: z.enum([
        'organization.created',
        'organization.suspended',
        'organization.reactivated',
        'organization.storage_destroyed',
        'user.invited',
        'user.invite_resent',
        'notification_broadcast.send',
        'operator.invited',
        'operator.invitation_resent',
        'operator.invitation_email_changed',
        'operator.invitation_revoked',
        'operator.activated',
        'operator.deactivated',
        'operator.reactivated',
        'operator.removed',
        'user.mfa_reset'
    ]),
    outcome: z.enum(['success', 'failure']),
    operatorId: z.union([
        z.string(),
        z.null()
    ]),
    operatorName: z.union([
        z.string(),
        z.null()
    ]),
    organization: z.union([
        z.object({
            id: z.string(),
            name: z.string()
        }),
        z.null()
    ]),
    metadata: z.union([
        z.record(z.string(), z.unknown()),
        z.null()
    ])
});

export const zOperatorAuditEventOrganization = z.object({
    id: z.string(),
    name: z.string()
});

export const zBackofficeOperator = z.object({
    id: z.string(),
    email: z.string(),
    name: z.union([
        z.string(),
        z.null()
    ]),
    status: z.enum([
        'invited',
        'expired',
        'active',
        'disabled'
    ]),
    invitationId: z.union([
        z.string(),
        z.null()
    ]),
    invitedAt: z.union([
        z.string(),
        z.null()
    ]),
    invitationExpiresAt: z.union([
        z.string(),
        z.null()
    ]),
    lastSignInAt: z.union([
        z.string(),
        z.null()
    ]),
    createdAt: zInstantOutput,
    isSelf: z.boolean()
});

export const zBackofficeClientPolicy = z.object({
    platforms: z.object({
        ios: zClientPlatformVersions,
        macos: zClientPlatformVersions,
        windows: zClientPlatformVersions,
        android: zClientPlatformVersions
    }),
    maintenance: zClientMaintenance,
    changedAt: zInstantOutput,
    changedBy: z.union([
        z.string(),
        z.null()
    ])
});

export const zBackofficeGetSessionSessionBlock = z.object({
    expiresAt: zInstantOutput,
    lastActivityAt: zInstantOutput,
    creationSource: z.string()
});

export const zBackofficeIdentity = z.object({
    id: z.string(),
    name: z.string(),
    email: z.union([
        z.string(),
        z.null()
    ])
});

export const zServiceHealth = z.object({
    isEssential: z.boolean(),
    isHealthy: z.boolean(),
    status: z.enum([
        'healthy',
        'degraded',
        'unhealthy'
    ]),
    checkedAt: z.union([
        z.string(),
        z.null()
    ]),
    diagnosis: z.union([
        z.object({
            cause: z.string()
        }),
        z.null()
    ])
});

export const zHealthDiagnosis = z.object({
    cause: z.string()
});

/**
 * `AbandonUploadsPayloadSchema` — the transfers to throw away.
 *
 * **Node ids and not upload ids**, which is the one shape decision here worth
 * arguing about. An `uploadId` names a row in `multipart_upload`, and a file
 * under the threshold goes up as a single PUT with no such row: a route keyed
 * on upload ids could not abandon one at all, which is half the cases and the
 * half that OPSSTD-5573 is about. Every open transfer has a node — that is
 * what holds the name — so the node is the only handle that names both kinds.
 * The panel carries `nodeId` on every row it draws.
 */
export const zAbandonUploadsPayload = z.object({
    nodeIds: z.array(z.string())
});

/**
 * Who an access line names, in a save and in the list it reads back
 * (OPSSTD-10425). Not the database's enum: a link's recipient is never named
 * here, it is the link's own business.
 */
export const zAccessSubjectType = z.enum(['user', 'group']);

export const zVersionsMeta = z.object({
    nextCursor: z.union([
        z.string(),
        z.null()
    ])
});

/**
 * `status: "completed"` — this path of this batch is already one of your
 * live files. Nothing to send.
 */
export const zBatchFileCompleted = z.object({
    status: z.enum(['completed']),
    relativePath: z.string(),
    nodeId: z.string()
});

/**
 * `status: "conflict"` — a complete file holds the name, whoever created it,
 * or your own unfinished transfer of a different file does, and the person
 * has to say what to do: announce it again with `onNameConflict`, or skip it.
 */
export const zBatchFileConflict = z.object({
    status: z.enum(['conflict']),
    relativePath: z.string(),
    code: z.enum(['own_file_exists', 'pending_upload_differs']),
    suggestedName: z.string()
});

/**
 * `status: "refused"` — this file is not confirmed.
 */
export const zBatchFileNotConfirmed = z.object({
    status: z.enum(['refused']),
    nodeId: z.string(),
    code: z.string()
});

/**
 * `status: "refused"` — the single route would have refused this file.
 */
export const zBatchFileRefused = z.object({
    status: z.enum(['refused']),
    relativePath: z.string(),
    code: z.string()
});

/**
 * A node the caller could see and no longer can: moved out of reach, sent to
 * the bin, deleted, or no longer shared with them.
 */
export const zChangeRemoved = z.object({
    type: z.enum(['removed']),
    nodeId: z.string()
});

/**
 * What the browser is being told to do with the bytes.
 *
 * It reaches the storage inside the presigned URL's
 * `response-content-disposition`, so it is **signed and not sent**, and the
 * caller of `authorize-download` chooses it.
 *
 * **Absent means `attachment`**, which is what every caller got before there
 * was a choice. The default is declared on the enum rather than at the call
 * site, so a route added later cannot land on the other one by forgetting to
 * say.
 */
export const zContentDisposition = z.enum(['attachment', 'inline']);

/**
 * `status: "authorized"` — one item's signed link.
 */
export const zDownloadAuthorized = z.object({
    status: z.enum(['authorized']),
    nodeId: z.string(),
    url: z.string(),
    fileName: z.string(),
    versionId: z.union([
        z.string(),
        z.null()
    ]),
    size: z.number(),
    checksum: z.union([
        z.string(),
        z.null()
    ]),
    expiresInSeconds: z.number()
});

/**
 * `status: "success"` — the plan.
 */
export const zDownloadPlanReady = z.object({
    status: z.enum(['success']),
    roots: z.array(z.object({
        nodeId: z.string(),
        name: z.string(),
        kind: z.enum(['folder', 'file'])
    })),
    files: z.array(z.object({
        nodeId: z.string(),
        rootId: z.string(),
        path: z.string(),
        size: z.number(),
        versionId: z.union([
            z.string(),
            z.null()
        ]),
        modifiedAt: z.string()
    })),
    emptyFolders: z.array(z.object({
        rootId: z.string(),
        path: z.string()
    })),
    totalFiles: z.number(),
    totalBytes: z.number()
});

/**
 * `status: "too_large"` — the selection holds more than one plan may.
 */
export const zDownloadPlanTooLarge = z.object({
    status: z.enum(['too_large']),
    maxFiles: z.number()
});

/**
 * `status: "refused"` — why one item got no link.
 */
export const zDownloadRefused = z.object({
    status: z.enum(['refused']),
    nodeId: z.string(),
    code: z.enum([
        'not_found',
        'state_conflict',
        'node_not_a_file'
    ])
});

/**
 * What became of one id.
 */
export const zFavoriteStatus = z.enum([
    'applied',
    'unchanged',
    'skipped'
]);

/**
 * One id's outcome.
 */
export const zFavoriteResult = z.object({
    nodeId: z.string(),
    status: zFavoriteStatus
});

/**
 * `FolderNameConflictSchema`.
 */
export const zFolderNameConflict = z.enum(['keepBoth']);

/**
 * A node as every client sees it — `NodeSchema`.
 */
export const zNode = z.object({
    id: z.string(),
    kind: z.enum(['folder', 'file']),
    category: z.enum([
        'folder',
        'document',
        'image',
        'spreadsheet',
        'archive',
        'video',
        'audio',
        'presentation',
        'other'
    ]),
    name: z.string(),
    parentId: z.union([
        z.string(),
        z.null()
    ]),
    state: z.enum([
        'active',
        'uploading',
        'upload_failed',
        'trashed',
        'purging',
        'purged'
    ]),
    size: z.union([
        z.number(),
        z.null()
    ]),
    version: z.number(),
    metaRevision: z.number(),
    personalOwnerId: z.union([
        z.string(),
        z.null()
    ]),
    createdAt: z.string(),
    updatedAt: z.string(),
    originalModifiedAt: z.union([
        z.string(),
        z.null()
    ]),
    favorite: z.boolean()
});

/**
 * `status: "completed"` — the file is live, as `POST
 * /directory/files/{nodeId}/upload/completion` answers it.
 */
export const zBatchFileConfirmed = z.object({
    status: z.enum(['completed']),
    nodeId: z.string(),
    node: zNode
});

/**
 * `status: "copied"`: the new file, live in the destination.
 */
export const zNodeCopied = z.object({
    status: z.enum(['copied']),
    nodeId: z.string(),
    node: zNode
});

/**
 * `status: "refused"`: why one file was not copied.
 */
export const zNodeCopyRefused = z.object({
    status: z.enum(['refused']),
    nodeId: z.string(),
    code: z.enum([
        'not_found',
        'node_not_a_file',
        'state_conflict',
        'storage_quota_exceeded',
        'invalid_name',
        'path_too_long',
        'max_depth_exceeded',
        'upload_verification_failed',
        'internal_error'
    ])
});

/**
 * The person a node belongs to — `NodeOwnerSchema`.
 *
 * Composed by the route from the node's own `created_by` rather than found
 * among the grants, and its own shape rather than a [`NodeAccess`] with
 * `role: "owner"`. From MS25 the owner is a column on the node, so a
 * node created since carries **no** `owner` grant at all and there is nothing
 * in the grant list to promote. Giving it a separate field means a client
 * never has to work out which row is the one it may not edit — the answer is
 * structural.
 *
 * No `role`, because there is only one thing it could say. No `granted_by`,
 * because nobody granted it.
 */
export const zNodeOwner = z.object({
    subjectId: z.string(),
    name: z.union([
        z.string(),
        z.null()
    ]),
    email: z.union([
        z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
        z.null()
    ])
});

/**
 * Where a received version came from: an upload link, and the name its sender
 * gave (OPSSTD-10427). Never an identifier or an address.
 */
export const zNodeReceivedThrough = z.object({
    senderName: z.string(),
    receivedAt: z.string()
});

/**
 * `NodeRole` (`constants.ts:199-203`), a Postgres enum named `node_role`.
 *
 * The `Ord` derive **is** `ROLE_ORDER` (`services/role.ts:3-9`): declaration
 * order is `viewer < editor < owner`, so `max()` over a set of roles is
 * `maxRole` and `>=` is `atLeast`. Written this way rather than as an
 * `index_of` lookup because a lattice whose ordering lives in a separate array
 * is a lattice with two definitions.
 * It is declared here and not taken from `dataplane_queries::types::dataplane::NodeRole`,
 * which the generator also produces from the same Postgres enum, and the
 * reason is the ordering. `Ord` on the generated enum would be the order the
 * **database** declares its labels in, so a `create type … as enum` rewritten
 * one day in alphabetical order would silently make `editor` outrank `owner`
 * and every authorization in this file would still compile. The lattice is a
 * product decision; the column is storage. [`NodeRole::from_column`] is the one
 * place the two meet, and it is a total `match`, so a fourth label added to the
 * enum in Postgres fails this crate's build instead of falling through.
 */
export const zNodeRole = z.enum([
    'viewer',
    'editor',
    'owner'
]);

/**
 * One step of a breadcrumb — `AncestorSchema`.
 *
 * Four fields and not a whole node: a breadcrumb needs a label, something to
 * navigate to, enough to know whether the last step is a folder, and what the
 * caller may do there. Sizes and timestamps would be a second copy of data the
 * client already fetches for the row itself.
 *
 * `role` is the fourth, and it is the difference between a path that can be
 * dropped onto and one that can only be read (OPSSTD-5846). Without it a
 * client had two ways to offer an action on a crumb, and both were worse:
 * accept the drop and let the server refuse it, or ask
 * `GET /directory/nodes/{nodeId}/grants` once per crumb on every folder
 * opened, for something this call already had in hand.
 */
export const zAncestor = z.object({
    id: z.string(),
    name: z.string(),
    kind: z.union([
        z.literal('folder'),
        z.literal('file')
    ]),
    role: zNodeRole
});

/**
 * A node the caller can see now, as it is now.
 */
export const zChangeUpsert = z.object({
    type: z.enum(['upsert']),
    node: zNode,
    role: zNodeRole
});

/**
 * The same access, plus the folder it was actually written on —
 * `InheritedNodeAccessSchema`.
 *
 * A separate shape rather than a nullable field on [`NodeAccess`], because the
 * difference is not cosmetic: an inherited access cannot be removed from that
 * screen. Two arrays make that structural, so a panel cannot put a *remove*
 * button on a row it would fail on.
 */
export const zInheritedNodeAccess = z.object({
    subjectType: zAccessSubjectType,
    subjectId: z.string(),
    name: z.union([
        z.string(),
        z.null()
    ]),
    email: z.union([
        z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
        z.null()
    ]),
    role: zNodeRole,
    grantedBy: z.union([
        z.string(),
        z.null()
    ]),
    createdAt: z.string(),
    source: z.object({
        id: z.string(),
        name: z.string()
    })
});

/**
 * One person's access to a node, as the sharing panel lists it —
 * `NodeAccessSchema`.
 *
 * `name` and `email` are nullable because a grant outlives the account it was
 * written for: dropping those rows from the answer would hide an access the
 * owner can still remove, and showing them with no name says what is true.
 */
export const zNodeAccess = z.object({
    subjectType: zAccessSubjectType,
    subjectId: z.string(),
    name: z.union([
        z.string(),
        z.null()
    ]),
    email: z.union([
        z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
        z.null()
    ]),
    role: zNodeRole,
    grantedBy: z.union([
        z.string(),
        z.null()
    ]),
    createdAt: z.string()
});

/**
 * Who sent something to the bin.
 */
export const zNodeTrashedBy = z.object({
    id: z.string(),
    name: z.union([
        z.string(),
        z.null()
    ]),
    email: z.union([
        z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
        z.null()
    ])
});

/**
 * Who published a version — the three fields an interface needs to name them.
 */
export const zNodeVersionAuthor = z.object({
    id: z.string(),
    name: z.union([
        z.string(),
        z.null()
    ]),
    email: z.union([
        z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
        z.null()
    ])
});

/**
 * One version of a file — `NodeVersionSchema`, the row of
 * `GET /v1/directory/nodes/{nodeId}/versions`.
 *
 * **No storage id and no ETag.** The first is what a download of this version
 * signs, and a client that held it could only use it to ask the store
 * directly — which it has no credential for, and should not try. The second is
 * a receipt the contract keeps off the wire everywhere else too.
 */
export const zNodeVersion = z.object({
    id: z.string(),
    versionNumber: z.number(),
    state: z.enum([
        'current',
        'historical',
        'purged'
    ]),
    size: z.number(),
    createdAt: z.string(),
    createdBy: z.union([
        zNodeVersionAuthor,
        z.null()
    ]),
    receivedThrough: z.union([
        zNodeReceivedThrough,
        z.null()
    ])
});

/**
 * A node plus what the caller may do with it — `NodeWithRoleSchema`.
 *
 * The grants that produced the role are deliberately absent: who *else* can
 * see a folder is not something a listing answers, and returning it would make
 * every shared folder a directory of colleagues.
 */
export const zNodeWithRole = z.object({
    node: zNode,
    role: zNodeRole
});

/**
 * `OnNameConflictSchema`.
 */
export const zOnNameConflict = z.enum(['keepBoth', 'replace']);

/**
 * The multipart half — `OpenUploadMultipartSchema`.
 *
 * **Told apart by `strategy` and never by which fields are present.** A client
 * that inferred *multipart* from a missing `url` would be a client that breaks
 * the day a field is added, and the choice is not the client's to make in the
 * first place: it follows from the size through the shared plan, which the
 * desktop, the web and this server all derive identically.
 */
export const zOpenUploadMultipart = z.object({
    status: z.enum(['success']),
    strategy: z.enum(['multipart']),
    node: zNode,
    partSize: z.number(),
    partCount: z.number(),
    meta: z.object({
        requestedName: z.union([
            z.string(),
            z.null()
        ]),
        resumed: z.boolean(),
        replaced: z.boolean()
    })
});

/**
 * The single-PUT half of what opening an upload answers —
 * `OpenUploadSingleSchema`.
 */
export const zOpenUploadSingle = z.object({
    status: z.enum(['success']),
    strategy: z.enum(['single']),
    node: zNode,
    url: z.string(),
    headers: z.record(z.string(), z.string()),
    expiresInSeconds: z.number(),
    meta: z.object({
        requestedName: z.union([
            z.string(),
            z.null()
        ]),
        resumed: z.boolean(),
        replaced: z.boolean()
    })
});

/**
 * `status: "opened"` — the file is announced, and `result` is what
 * `POST /directory/files` answers for it.
 */
export const zBatchFileOpened = z.object({
    status: z.enum(['opened']),
    relativePath: z.string(),
    result: z.union([
        z.object({
            strategy: z.literal('single')
        }).and(zOpenUploadSingle),
        z.object({
            strategy: z.literal('multipart')
        }).and(zOpenUploadMultipart)
    ])
});

/**
 * `OrgLinkState.ceiling` — the organization's `link.internal`.
 */
export const zOrgLinkCeiling = z.enum([
    'off',
    'viewer',
    'editor'
]);

/**
 * A node's opening to its organization — `OrgLinkState` — as it is in force
 * right now, after the organization's `link.internal`.
 *
 * What `PUT /directory/nodes/{nodeId}/org-link` answers with and what
 * `NodeDetail.orgLink` carries, so a save replaces the section it was made
 * from without a second read.
 */
export const zOrgLinkState = z.object({
    role: z.union([
        zNodeRole,
        z.null()
    ]),
    inheritedFrom: z.union([
        z.object({
            id: z.string(),
            name: z.string(),
            role: zNodeRole
        }),
        z.null()
    ]),
    ceiling: zOrgLinkCeiling
});

/**
 * `OriginViaSchema` — what opened the top of a breadcrumb to the caller.
 */
export const zOriginVia = z.enum(['grant', 'organization']);

/**
 * One row of a public folder listing.
 */
export const zPublicListedNode = z.object({
    id: z.string(),
    kind: z.enum(['folder', 'file']),
    category: z.enum([
        'folder',
        'document',
        'image',
        'spreadsheet',
        'archive',
        'video',
        'audio',
        'presentation',
        'other'
    ]),
    name: z.string(),
    size: z.union([
        z.number(),
        z.null()
    ]),
    updatedAt: z.string(),
    path: z.string(),
    childCount: z.union([
        z.number(),
        z.null()
    ])
});

/**
 * The node a link points to, as a stranger sees it: what it is and what it is
 * called. No parent, no owner, no version — nothing about where it sits.
 */
export const zPublicNode = z.object({
    id: z.string(),
    kind: z.enum(['folder', 'file']),
    category: z.enum([
        'folder',
        'document',
        'image',
        'spreadsheet',
        'archive',
        'video',
        'audio',
        'presentation',
        'other'
    ]),
    name: z.string(),
    size: z.union([
        z.number(),
        z.null()
    ])
});

/**
 * One step of the way down from the link's folder to the one being listed.
 */
export const zPublicPathStep = z.object({
    id: z.string(),
    name: z.string()
});

export const zPublicListingMeta = z.object({
    nextCursor: z.union([
        z.string(),
        z.null()
    ]),
    path: z.array(zPublicPathStep)
});

export const zPublicThumbnailItem = z.object({
    nodeId: z.string(),
    status: z.enum([
        'ready',
        'missing',
        'not_found'
    ]),
    url: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    expiresAt: z.optional(z.union([
        z.string(),
        z.null()
    ]))
});

/**
 * What an upload link takes, for the page to refuse early what the announce
 * would refuse anyway.
 */
export const zPublicUploadTerms = z.object({
    maxFileSizeBytes: z.number()
});

/**
 * What an unlocked link shows. Every download link lets its holder preview
 * and download (OPSSTD-8559); an upload link lets them send files into the
 * folder and shows nothing of what is in it (OPSSTD-10427).
 */
export const zPublicLinkDetail = z.object({
    kind: z.enum(['download', 'upload']),
    expiresAt: z.union([
        z.string(),
        z.null()
    ]),
    node: zPublicNode,
    sharedBy: z.union([
        z.string(),
        z.null()
    ]),
    description: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    upload: z.optional(z.union([
        zPublicUploadTerms,
        z.null()
    ]))
});

/**
 * One item this call would not destroy, and why.
 */
export const zPurgeRefusal = z.object({
    nodeId: z.string(),
    code: z.string(),
    details: z.union([
        z.record(z.string(), z.unknown()),
        z.null()
    ])
});

/**
 * `onNameConflict` on a restore. One value, because a restore never
 * overwrites: the only thing the person can ask for, beyond the plain
 * restore, is to take the free name instead.
 */
export const zRestoreNameConflict = z.enum(['rename']);

/**
 * One item this call could not bring back, and why.
 */
export const zRestoreRefusal = z.object({
    nodeId: z.string(),
    code: z.string(),
    details: z.union([
        z.record(z.string(), z.unknown()),
        z.null()
    ])
});

/**
 * One item that came back.
 */
export const zRestoredNode = z.object({
    node: zNode,
    requestedName: z.union([
        z.string(),
        z.null()
    ])
});

/**
 * One folder strictly between a search hit's accessible root and the hit
 * itself — `SearchResultPathSegmentSchema`.
 */
export const zSearchResultPathSegment = z.object({
    id: z.string(),
    name: z.string()
});

/**
 * Which side of the caller's own tree a search hit's accessible root sits
 * on — `SearchRootTypeSchema`. The Rust spelling of
 * `crate::directory::search_roots::RootKind`, kept as its own type because
 * that one is an internal fact about a root and this one is what the wire
 * promises about a hit.
 */
export const zSearchRootType = z.enum([
    'personal',
    'shared',
    'trash'
]);

/**
 * The person behind a share — `SharerSchema`.
 */
export const zSharer = z.object({
    id: z.string(),
    name: z.union([
        z.string(),
        z.null()
    ]),
    email: z.union([
        z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
        z.null()
    ])
});

/**
 * One row of the favorites listing — `FavoriteSchema` (OPSSTD-10641).
 *
 * A [`ListedNode`] and one more field, extended rather than set beside it for
 * the reason [`SearchHitRecord`] is: the page draws a favorite with the same
 * card and the same menu as a folder's contents, so the generated client's
 * row *is* the listing row, one field wider.
 */
export const zFavoriteRecord = z.object({
    node: zNode,
    role: zNodeRole
}).and(z.object({
    childCount: z.union([
        z.number(),
        z.null()
    ]),
    folderCount: z.union([
        z.number(),
        z.null()
    ]),
    shared: z.boolean(),
    owner: z.union([
        zSharer,
        z.null()
    ])
})).and(z.object({
    favoritedAt: z.string()
}));

/**
 * One upload somebody else has running inside a folder — `FolderUploadSchema`.
 *
 * Deliberately not [`UploadInProgress`] with the fields renamed. That one
 * describes a transfer the caller can act on, and every field it carries is
 * there to be acted on: an `uploadId` to post a resumption to, a part count, a
 * percentage. None of those mean anything about somebody else's transfer —
 * there is nothing to resume and nothing to continue — and a shared type would
 * have to make each of them optional, which is how a response stops saying
 * what it means.
 *
 * **No percentage, and that is a decision rather than an omission.** It is
 * derivable from rows in this database, but without a live feed it would be
 * frozen at whatever it was when the page rendered, and a percentage that does
 * not move reads as a stalled transfer. It is additive when the realtime feed
 * arrives.
 */
export const zFolderUpload = z.object({
    nodeId: z.string(),
    name: z.string(),
    sizeBytes: z.union([
        z.number(),
        z.null()
    ]),
    startedAt: z.string(),
    uploadedBy: z.union([
        zSharer,
        z.null()
    ]),
    fileCount: z.number(),
    batchId: z.union([
        z.string(),
        z.null()
    ])
});

/**
 * A row as a *listing* returns it — `ListedNodeSchema`.
 *
 * An extension of [`NodeWithRole`] rather than two more fields on it, for the
 * reason that schema's other consumer makes plain: `get-nodes` reads it too,
 * and resolves nodes by id without ever asking what is inside them. A count
 * published there would be a field the server never computed — absent, or zero
 * — and either way a number a client would render as true.
 *
 * Both listings extend *this*, so the two routes carry the field by
 * construction rather than by copy. A folder's card is drawn the same way
 * inside a folder and among the shared roots, so the number behind it is one
 * number. It is the same reasoning [`SharedRoot`] records below.
 *
 * Flattened, so the wire shape is `NodeWithRole`'s two fields plus one rather
 * than a nested object: the generated client widens the grid's row type, and a
 * nesting here would make that a different type instead of a wider one.
 */
export const zListedNode = z.object({
    node: zNode,
    role: zNodeRole
}).and(z.object({
    childCount: z.union([
        z.number(),
        z.null()
    ]),
    folderCount: z.union([
        z.number(),
        z.null()
    ]),
    shared: z.boolean(),
    owner: z.union([
        zSharer,
        z.null()
    ])
}));

/**
 * One node read on its own, with both hands on it — `NodeDetailSchema`.
 *
 * **A type beside `ListedNode`, never a widening of it.** `NodeRecord` is the
 * wire shape frozen on 30/09 and `NodeWithRole` is what every listing row is;
 * putting two people on either would change the response of every route that
 * draws a grid, to serve the one route that asks about a single node. So the
 * extra fields live here, and the batch read stays exactly what it was.
 *
 * Flattened over `ListedNode` for the reason `ListedNode` is flattened over
 * `NodeWithRole`: the generated client gets a row type that is wider than the
 * grid's rather than a different one, so a panel and a listing can be handed
 * the same node.
 *
 * `createdBy` is also who owns the node — ownership is a property of the node
 * rather than a grant. Both people are null under the same two
 * conditions and no third: nobody was recorded, or the account is gone. A
 * client shows the date without a name rather than an identifier.
 *
 * **Making a node counts as the last hand on it**, so the two are the same
 * person until somebody renames, moves or rewrites it. The alternative was to
 * leave `modifiedBy` null until then, and it does not survive contact with the
 * two kinds of node: a file takes its first stamp from the confirm of version
 * 1, so it would have had a name from the moment it existed while a folder had
 * none, for no reason a person looking at the panel could see. It would also
 * have left a date labelled «modified» sitting above no name at all on
 * something nobody had modified.
 */
export const zNodeDetail = z.object({
    node: zNode,
    role: zNodeRole
}).and(z.object({
    childCount: z.union([
        z.number(),
        z.null()
    ]),
    folderCount: z.union([
        z.number(),
        z.null()
    ]),
    shared: z.boolean(),
    owner: z.union([
        zSharer,
        z.null()
    ])
})).and(z.object({
    createdBy: z.union([
        zSharer,
        z.null()
    ]),
    modifiedBy: z.union([
        zSharer,
        z.null()
    ]),
    orgLink: zOrgLinkState,
    receivedThrough: z.union([
        zNodeReceivedThrough,
        z.null()
    ])
}));

/**
 * One row of «Recenti» — `RecentRow`.
 *
 * A [`ListedNode`] and the date it is ordered by, extended for the reason
 * [`FavoriteRecord`] is: a recent file is drawn with the same card and the
 * same menu as a folder's contents. Not a [`SearchHitRecord`], although the
 * rows come out of the same roots: a recent file has no relevance and no
 * place to be shown relative to, so `rootId`, `rootType` and `path` would be
 * three fields every client ignores, and the one it needs would be missing.
 */
export const zRecentRow = z.object({
    node: zNode,
    role: zNodeRole
}).and(z.object({
    childCount: z.union([
        z.number(),
        z.null()
    ]),
    folderCount: z.union([
        z.number(),
        z.null()
    ]),
    shared: z.boolean(),
    owner: z.union([
        zSharer,
        z.null()
    ])
})).and(z.object({
    contentChangedAt: z.string()
}));

/**
 * One row of a search result — `SearchHitSchema`.
 *
 * A [`ListedNode`] plus the three facts T32.4 needs that a listing row alone
 * cannot answer: which accessible root the hit came from, which side of the
 * tree that root is on, and the path down to the hit **relative to that
 * root, and never anything above it** — `rootId` and `path` together are
 * what let a client draw a breadcrumb without ever being handed an ancestor
 * id it has no right to see. All three are attributed once per hit from data
 * the route already holds (`search_roots::attribute`), never from a fresh
 * per-row permission check — see that function's own doc for why several
 * roots can structurally match one hit and which one this module picks.
 *
 * **It extends the listing row rather than sitting beside it, and this is a
 * contract decision rather than a convenience.** A search result is drawn by
 * the same card and the same list row as a folder's contents, with the same
 * menu and the same selection on it, and the T32 design asks for exactly
 * that. Extending means the generated client's search row *is* a listing row
 * with three fields more, so the shared components take it without a mapper
 * standing between them fabricating what the wire did not say. A parallel
 * shape would have compiled just as well and drifted the first time either
 * side grew a field.
 *
 * **This used to carry neither `role` nor `childCount`, deliberately**, and
 * the reason it no longer does is worth stating because it was a good reason.
 * The fear was reintroducing the per-row permission evaluation OPSSTD-7602
 * forbids — a search has no single parent whose role every row shares, so the
 * naive shape pays a chain resolution per hit. Neither field does that.
 * `role` is folded from grants the route reads in **one** statement over the
 * page's own chains, on top of a floor `search_roots` already paid for per
 * root; `childCount` is the same grouped statement both listings issue, over
 * the page's folders. The statement count per request is fixed, exactly as it
 * was.
 *
 * `path` is empty for a hit sitting directly under its root, and empty too
 * when the hit **is** the root: a root's own ancestors are exactly what must
 * never be named, the same boundary [`NodeRecord::parent_id`] already
 * respects by nulling itself on a root.
 */
export const zSearchHit = z.object({
    node: zNode,
    role: zNodeRole
}).and(z.object({
    childCount: z.union([
        z.number(),
        z.null()
    ]),
    folderCount: z.union([
        z.number(),
        z.null()
    ]),
    shared: z.boolean(),
    owner: z.union([
        zSharer,
        z.null()
    ])
})).and(z.object({
    rootId: z.string(),
    rootType: zSearchRootType,
    path: z.array(zSearchResultPathSegment)
}));

/**
 * How the caller came to see the top of a breadcrumb — `SharedOriginSchema`.
 */
export const zSharedOrigin = z.object({
    via: zOriginVia,
    role: zNodeRole,
    sharedAt: z.string(),
    sharedBy: z.union([
        zSharer,
        z.null()
    ])
});

/**
 * A row of "Shared with me" — `SharedRootSchema`.
 */
export const zSharedRoot = z.object({
    node: zNode,
    role: zNodeRole,
    childCount: z.union([
        z.number(),
        z.null()
    ]),
    folderCount: z.union([
        z.number(),
        z.null()
    ]),
    owner: z.union([
        zSharer,
        z.null()
    ]),
    sharedBy: z.union([
        zSharer,
        z.null()
    ]),
    sharedAt: z.string(),
    via: zOriginVia
});

/**
 * One part the client is authorized to write — `SignedPartSchema`.
 */
export const zSignedPart = z.object({
    partNumber: z.number(),
    offset: z.number(),
    length: z.number(),
    url: z.string()
});

/**
 * One file's answer.
 */
export const zThumbnailItem = z.object({
    nodeId: z.string(),
    status: z.enum([
        'ready',
        'missing',
        'unsupported',
        'not_found'
    ]),
    url: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    expiresAt: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    storageVersionId: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    sourceUrl: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    uploadUrl: z.optional(z.union([
        z.string(),
        z.null()
    ])),
    uploadHeaders: z.optional(z.union([
        z.record(z.string(), z.string()),
        z.null()
    ]))
});

/**
 * [`TrashItem::owner`] — the two fields a client needs to name whom to ask.
 */
export const zTrashItemOwner = z.object({
    id: z.string(),
    name: z.union([
        z.string(),
        z.null()
    ])
});

export const zTrashMeta = z.object({
    nextCursor: z.union([
        z.string(),
        z.null()
    ])
});

/**
 * The folder an item was binned from, as the caller can see it.
 */
export const zTrashOrigin = z.object({
    id: z.string(),
    name: z.string(),
    path: z.array(zSearchResultPathSegment)
});

/**
 * One line of [`PreviewTrashResponse::data`].
 */
export const zTrashPreviewItem = z.object({
    nodeId: z.string(),
    count: z.number()
});

/**
 * One node this call could not size, and why — [`PreviewTrashResponse::refused`].
 */
export const zTrashPreviewRefusal = z.object({
    nodeId: z.string(),
    code: z.string()
});

/**
 * One entry of [`TrashNodesResponse::refused`].
 */
export const zTrashRefusal = z.object({
    nodeId: z.string(),
    code: z.string()
});

/**
 * One item of the bin — `TrashedNodeSchema`, the row of
 * `GET /v1/directory/trash`.
 *
 * The node as every listing shows it, plus the three facts the bin needs:
 * when it went there, who sent it, and the folder it came from.
 */
export const zTrashedNode = z.object({
    node: zNode,
    trashedAt: z.union([
        z.string(),
        z.null()
    ]),
    expiresAt: z.union([
        z.string(),
        z.null()
    ]),
    trashedBy: z.union([
        zNodeTrashedBy,
        z.null()
    ]),
    originalParent: z.union([
        zTrashOrigin,
        z.null()
    ]),
    canPurge: z.boolean(),
    owner: z.union([
        zTrashItemOwner,
        z.null()
    ])
});

/**
 * One of the caller's folder uploads that still has files on their way —
 * `UploadBatchSchema` (OPSSTD-10435). What the panel offers to resume after
 * a reload, or to give up whole.
 */
export const zUploadBatch = z.object({
    batchId: z.string(),
    rootId: z.string(),
    rootName: z.string(),
    destinationId: z.union([
        z.string(),
        z.null()
    ]),
    pendingFiles: z.number(),
    pendingBytes: z.number(),
    completedFiles: z.number(),
    startedAt: z.string()
});

/**
 * An upload the caller left running — `UploadInProgressSchema`.
 *
 * `declaredName` and `declaredSizeBytes` are what the transfer was **opened
 * against**, not what the node is called now: the node can be renamed while
 * the upload runs, and the resume check compares the file the person picks
 * again with what was opened rather than with what the directory currently
 * says.
 *
 * **A row here is not always a node in `uploading`.** `onNameConflict:
 * "replace"` opens a multipart transfer on a node that stays `active` the
 * whole time — see `data-plane/crates/dataplane/migrations/
 * V10__a_replacing_file_holds_its_place.sql` — and once that transfer's own
 * `POST /files/{nodeId}/upload` has been called, its row lands here exactly
 * like any other open multipart upload, because [`crate::directory::multipart::uploads_in_progress`]
 * reads `multipart_upload` and never asks what state the node is in. Nothing
 * in this shape says which of the two a row is: `node.state` is not a field
 * here, and a client that reads it separately — to draw a badge, say — will
 * find `active` rather than `uploading` for this one row. Resuming and
 * abandoning both work unchanged either way; a consumer that assumed every
 * row here belongs to a not-yet-visible file does not hold for this one.
 */
export const zUploadInProgress = z.object({
    uploadId: z.string(),
    nodeId: z.string(),
    parentId: z.union([
        z.string(),
        z.null()
    ]),
    declaredName: z.string(),
    declaredSizeBytes: z.number(),
    partCount: z.number(),
    confirmedParts: z.number(),
    progressPercent: z.number(),
    resumeExpiresAt: z.string(),
    batchId: z.union([
        z.string(),
        z.null()
    ])
});

export const zDocsSchemaData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

export const zV1AppConfigGetStatusData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1AppConfigGetStatusResponse = z.object({
    data: zAppConfigStatus
});

export const zV1AppConfigGetClientsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1AppConfigGetClientsResponse = z.object({
    data: zClientPolicy
});

export const zV1AppConfigGetLoginBrandingData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1AppConfigGetLoginBrandingResponse = z.object({
    version: z.string(),
    instance: zLoginBrandingInstance
});

export const zV1AppConfigGetLoginBrandingImageData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        slot: z.enum([
            'logo',
            'logo-dark',
            'mark',
            'mark-dark',
            'favicon',
            'background',
            'background-dark'
        ])
    }),
    query: z.optional(z.object({
        v: z.optional(z.string())
    }))
});

export const zV1AssetsCreateAssetsData = z.object({
    body: z.object({
        data: z.object({
            fileName: z.string().min(1),
            mimeType: z.string().min(1),
            sizeInBytes: z.int().gt(0).lte(9007199254740991),
            scope: z.enum(['user_photo'])
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1AssetsCreateAssetsResponse = z.object({
    data: zCreatedAsset
});

export const zV1AssetsGetAssetData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        assetId: z.string().min(1),
        variant: z.enum([
            'original',
            'thumbnail',
            'small',
            'medium',
            'large'
        ])
    }),
    query: z.optional(z.never())
});

export const zV1AuthSignOutData = z.object({
    body: z.object({
        token: z.optional(z.string().min(1)),
        pushToken: z.optional(z.string().min(1))
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1AuthSignOutResponse = z.object({
    status: z.enum(['success'])
});

export const zV1AuthGetSessionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1AuthGetSessionResponse = z.object({
    sessionType: z.enum(['anonymous', 'authenticated']),
    csrfToken: z.union([
        z.string(),
        z.null()
    ]),
    session: z.union([
        z.object({
            expiresAt: zInstantOutput,
            lastActivityAt: zInstantOutput,
            creationSource: z.string()
        }),
        z.null()
    ]),
    user: z.union([
        z.object({
            id: z.string(),
            isAnonymous: z.boolean()
        }),
        z.null()
    ]),
    organization: z.union([
        z.object({
            id: z.string(),
            name: z.string(),
            slug: z.string()
        }),
        z.null()
    ]),
    role: z.nullable(z.enum(['org_admin', 'member']))
});

export const zV1AuthRefreshData = z.object({
    body: z.object({
        token: z.string().min(1)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1AuthRefreshResponse = z.object({
    status: z.enum(['success']),
    token: z.string(),
    csrfToken: z.string(),
    expiresAt: zInstantOutput
});

export const zV1AuthRevokeSessionsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        scope: z.enum([
            'session',
            'other_sessions',
            'all_sessions',
            'organization'
        ]),
        sessionId: z.optional(z.string()),
        userId: z.optional(z.string())
    })
});

/**
 * Default Response
 */
export const zV1AuthRevokeSessionsResponse = z.object({
    data: zRevokeSessionsData
});

export const zV1AuthListSessionsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gt(0).lte(9007199254740991)).default(1),
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
        status: z.optional(z.union([
            z.enum([
                'active',
                'revoked',
                'expired'
            ]),
            z.array(z.enum([
                'active',
                'revoked',
                'expired'
            ])).min(1).max(3)
        ]))
    }))
});

/**
 * Default Response
 */
export const zV1AuthListSessionsResponse = z.object({
    data: z.array(zSessionListItem),
    meta: zOffsetPaginationMeta
});

export const zV1AuthRevokeSessionData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        sessionId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1AuthRevokeSessionResponse = z.object({
    status: z.enum(['success'])
});

export const zV1AuthRequestEmailChangeData = z.object({
    body: z.object({
        newEmail: z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1AuthRequestEmailChangeResponse = z.object({
    status: z.enum(['success']),
    currentEmailVerificationRequired: z.boolean(),
    emailOtpToken: z.string()
});

export const zV1AuthConfirmEmailChangeData = z.object({
    body: z.object({
        newEmail: z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
        newOtp: z.string().min(1),
        currentOtp: z.optional(z.string().min(1)),
        emailOtpToken: z.string()
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1AuthConfirmEmailChangeResponse = z.object({
    status: z.enum(['success'])
});

export const zV1AuthDeleteUserData = z.object({
    body: z.object({
        token: z.optional(z.string()),
        emailOtpToken: z.optional(z.string())
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1AuthDeleteUserResponse = z.union([
    z.object({
        status: z.literal('success')
    }).and(zStatusSuccessResponse),
    z.object({
        status: z.literal('requires_otp')
    }).and(zDeleteAccountRequiresOtp)
]);

export const zV1AuthStartOidcLoginData = z.object({
    body: z.object({
        slug: z.string().min(1),
        returnPath: z.optional(z.string()),
        locale: z.optional(z.enum(['en', 'it']))
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1AuthStartOidcLoginResponse = z.object({
    data: z.object({
        authorizationUrl: z.string()
    })
});

export const zV1AuthOidcNativeAuthorizationsData = z.object({
    body: z.object({
        slug: z.string().min(1),
        platform: z.enum([
            'ios',
            'android',
            'macos',
            'windows'
        ]),
        locale: z.enum(['en', 'it']),
        codeChallenge: z.string().regex(/^[A-Za-z0-9_-]{43}$/)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1AuthOidcNativeAuthorizationsResponse = z.object({
    data: z.object({
        startUrl: z.string()
    })
});

export const zV1AuthOidcNativeAuthorizationsOpenData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        startId: z.string()
    }),
    query: z.optional(z.never())
});

export const zV1AuthNativeSessionsData = z.object({
    body: z.object({
        data: z.object({
            code: z.string().min(1).max(128),
            codeVerifier: z.string().min(1).max(128),
            device: zNativeDevice
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1AuthNativeSessionsResponse = z.object({
    data: zNativeSession
});

export const zV1AuthNativeSessionsRenewalsData = z.object({
    body: z.object({
        data: z.object({
            refreshToken: z.string().min(1).max(512)
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1AuthNativeSessionsRenewalsResponse = z.object({
    data: zNativeSession
});

export const zV1AuthNativeSessionsCurrentData = z.object({
    body: z.object({
        refreshToken: z.string().min(1).max(512)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1AuthNativeSessionsCurrentResponse = z.object({
    status: z.enum(['success'])
});

export const zV1AuthOidcCallbackData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        code: z.optional(z.string()),
        state: z.optional(z.string()),
        error: z.optional(z.string()),
        error_description: z.optional(z.string()),
        kc_action: z.optional(z.string()),
        kc_action_status: z.optional(z.string())
    }))
});

export const zV1AuthOidcLogoutData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1AuthOidcLogoutResponse = z.object({
    status: z.enum(['success'])
});

export const zV1AuthValidateInviteData = z.object({
    body: z.object({
        code: z.string().min(1).max(512)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1AuthValidateInviteResponse = z.object({
    data: zInvitation
});

export const zV1AuthActivateInviteData = z.object({
    body: z.object({
        code: z.string().min(1).max(512),
        password: z.string().min(1).max(256),
        firstName: z.string().min(1).max(128),
        lastName: z.string().min(1).max(128)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1AuthActivateInviteResponse = z.object({
    data: z.object({
        authorizationUrl: z.string(),
        signedIn: z.boolean()
    })
});

export const zV1AuthStartAccountActionData = z.object({
    body: z.union([
        z.object({
            action: z.enum([
                'update-password',
                'configure-otp',
                'regenerate-recovery-codes'
            ])
        }),
        z.object({
            action: z.enum(['remove-otp-device']),
            deviceId: z.string().min(1)
        })
    ]),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1AuthStartAccountActionResponse = z.object({
    data: z.object({
        authorizationUrl: z.string()
    })
});

export const zV1AuthOidcNativeAccountActionsData = z.object({
    body: z.union([
        z.object({
            action: z.enum([
                'update-password',
                'configure-otp',
                'regenerate-recovery-codes'
            ]),
            platform: z.enum([
                'ios',
                'android',
                'macos',
                'windows'
            ])
        }),
        z.object({
            action: z.enum(['remove-otp-device']),
            deviceId: z.string().min(1),
            platform: z.enum([
                'ios',
                'android',
                'macos',
                'windows'
            ])
        })
    ]),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1AuthOidcNativeAccountActionsResponse = z.object({
    data: z.object({
        startUrl: z.string()
    })
});

export const zV1AuditListEventsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        cursor: z.optional(z.string()),
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
        from: z.optional(zInstant),
        to: z.optional(zInstant),
        personId: z.optional(z.string()),
        actions: z.optional(z.array(z.enum([
            'authz.denied',
            'policy.changed',
            'audit.retention_applied',
            'share.granted',
            'share.role_changed',
            'share.revoked',
            'group.created',
            'group.updated',
            'group.deleted',
            'group.member_added',
            'group.member_removed',
            'node.purged',
            'node.version_deleted',
            'node.versions_expired',
            'upload.expired',
            'node.upload_reconciled',
            'user.invited',
            'user.invite_accepted',
            'user.invite_resent',
            'user.removed',
            'user.email_changed',
            'user.deactivated',
            'user.reactivated',
            'user.membership_removed',
            'user.role_changed',
            'user.owner_granted',
            'user.quota_changed',
            'user.owner_revoked',
            'session.revoked',
            'session.force_disconnected',
            'user.credentials_changed',
            'organization.created',
            'organization.suspended',
            'organization.reactivated',
            'organization.quota_changed',
            'organization.version_retention_changed',
            'organization.storage_destroyed',
            'link.created',
            'link.updated',
            'link.revoked',
            'link.accessed',
            'link.previewed',
            'link.downloaded',
            'link.password_locked',
            'link.upload_limited',
            'org_link.changed',
            'org_link.opened'
        ])).min(1)),
        objectType: z.optional(z.string()),
        objectId: z.optional(z.string()),
        batchKinds: z.optional(z.array(z.enum([
            'upload',
            'download',
            'preview',
            'trash',
            'restore',
            'version_restore',
            'copy'
        ])).min(1))
    }))
});

/**
 * Default Response
 */
export const zV1AuditListEventsResponse = z.object({
    data: z.array(zAuditTimelineEntry),
    meta: z.object({
        total: z.number(),
        nextCursor: z.union([
            z.string(),
            z.null()
        ]),
        retention: zAuditRetention,
        person: z.union([
            z.object({
                name: z.union([
                    z.string(),
                    z.null()
                ])
            }),
            z.null()
        ])
    })
});

export const zV1AuditListMyEventsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        cursor: z.optional(z.string()),
        limit: z.optional(z.int().gte(1).lte(50)).default(50)
    }))
});

/**
 * Default Response
 */
export const zV1AuditListMyEventsResponse = z.object({
    data: z.array(zAuditTimelineEntry),
    meta: z.object({
        total: z.number(),
        nextCursor: z.union([
            z.string(),
            z.null()
        ]),
        retention: zAuditRetention
    })
});

export const zV1UsersGetMeData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1UsersGetMeResponse = z.object({
    data: zUser
});

export const zV1UsersUpdateMeData = z.object({
    body: z.object({
        name: z.optional(z.string()),
        image: z.optional(z.union([
            z.string().regex(/^ast_.*/),
            z.null()
        ]))
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1UsersUpdateMeResponse = z.object({
    data: zUser
});

export const zV1UsersGetMePreferencesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1UsersGetMePreferencesResponse = z.object({
    data: zUserPreferencesData
});

export const zV1UsersUpdateMePreferencesData = z.object({
    body: z.object({
        language: z.optional(z.enum(['en', 'it'])),
        theme: z.optional(z.enum([
            'light',
            'dark',
            'system'
        ])),
        completedTutorial: z.optional(z.string().regex(/^(?:ios|macos|android|windows)\.[a-z0-9][a-z0-9_-]{0,47}$/)),
        tutorialsDismissed: z.optional(z.boolean())
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1UsersUpdateMePreferencesResponse = z.object({
    data: zUserPreferencesData
});

export const zV1UsersGetMeSecurityData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1UsersGetMeSecurityResponse = z.object({
    data: zAccountSecurity
});

export const zV1UsersGetMeStorageData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1UsersGetMeStorageResponse = z.object({
    data: zPersonStorage
});

export const zV1UsersSearchUsersData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        cursor: z.optional(z.string()),
        limit: z.optional(z.int().gte(1).lte(20)).default(10),
        q: z.optional(z.string().min(1).max(100)),
        ids: z.optional(z.array(z.string().min(1)).min(1).max(50)),
        includeSelf: z.optional(z.string())
    }))
});

/**
 * Default Response
 */
export const zV1UsersSearchUsersResponse = z.object({
    data: z.array(zUserSearchResult),
    meta: zCursorPaginationMeta
});

export const zV1PushDevicesDeleteData = z.object({
    body: z.object({
        token: z.string().min(1)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

export const zV1PushDevicesRegisterData = z.object({
    body: z.object({
        token: z.string().min(1).max(4096),
        platform: z.enum([
            'ios',
            'macos',
            'android'
        ]),
        apnsEnvironment: z.optional(z.enum(['production', 'sandbox'])),
        apnsPushType: z.optional(z.enum([
            'fileprovider',
            'background',
            'alert'
        ])),
        fileProviderDomain: z.optional(z.string().min(1).max(256)),
        payloadKey: z.optional(z.string().regex(/^[A-Za-z0-9+\/]{43}=$/)),
        deviceName: z.optional(z.union([
            z.string(),
            z.null()
        ]))
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1PushDevicesRegisterResponse = z.object({
    data: z.object({
        id: z.string(),
        userId: z.string(),
        platform: z.enum([
            'ios',
            'macos',
            'android'
        ]),
        apnsEnvironment: z.nullable(z.enum(['production', 'sandbox'])),
        apnsPushType: z.nullable(z.enum([
            'fileprovider',
            'background',
            'alert'
        ])),
        fileProviderDomain: z.union([
            z.string(),
            z.null()
        ]),
        deviceName: z.union([
            z.string(),
            z.null()
        ]),
        isValid: z.boolean(),
        createdAt: zInstantOutput,
        updatedAt: zInstantOutput
    })
});

export const zV1LinksListMyLinksData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        cursor: z.optional(z.string()),
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
        state: z.optional(z.array(z.enum([
            'active',
            'expired',
            'revoked',
            'policy_blocked'
        ])).min(1).max(4)),
        search: z.optional(z.string().min(1).max(256)),
        kind: z.optional(z.enum(['download', 'upload']))
    }))
});

/**
 * Default Response
 */
export const zV1LinksListMyLinksResponse = z.object({
    data: z.array(zLink),
    meta: zCursorPaginationMeta
});

export const zV1LinksCreateLinkData = z.object({
    body: z.object({
        data: z.object({
            nodeId: z.string(),
            kind: z.optional(z.enum(['download', 'upload'])),
            password: z.optional(z.string().min(1)),
            expiresAt: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            description: z.optional(z.string().max(500))
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1LinksCreateLinkResponse = z.object({
    data: zLink
});

export const zV1LinksGetNodeLinksData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        nodeId: z.string()
    }),
    query: z.optional(z.object({
        kind: z.optional(z.enum(['download', 'upload']))
    }))
});

/**
 * Default Response
 */
export const zV1LinksGetNodeLinksResponse = z.object({
    data: zNodeLinks
});

export const zV1LinksRevokeLinkData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        linkId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1LinksRevokeLinkResponse = z.object({
    status: z.enum(['success'])
});

export const zV1LinksUpdateLinkData = z.object({
    body: z.object({
        expiresAt: z.optional(z.union([
            z.string(),
            z.null()
        ])),
        password: z.optional(z.union([
            z.string().min(1),
            z.null()
        ])),
        description: z.optional(z.union([
            z.string().max(500),
            z.null()
        ]))
    }),
    path: z.object({
        linkId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1LinksUpdateLinkResponse = z.object({
    data: zLink
});

export const zV1LinksListActiveLinksData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        cursor: z.optional(z.string()),
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
        creatorId: z.optional(z.string()),
        state: z.optional(z.array(z.enum([
            'active',
            'expired',
            'revoked',
            'policy_blocked'
        ])).min(1).max(4)),
        expiresWithinDays: z.optional(z.int().gt(0).lte(9007199254740991)),
        hasPassword: z.optional(z.string()),
        kind: z.optional(z.enum(['download', 'upload']))
    }))
});

/**
 * Default Response
 */
export const zV1LinksListActiveLinksResponse = z.object({
    data: z.array(zAdminLink),
    meta: zCursorPaginationMeta
});

export const zV1LinksBulkRevokeLinksData = z.object({
    body: z.object({
        data: z.object({
            creatorId: z.string()
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1LinksBulkRevokeLinksResponse = z.object({
    status: z.enum(['success']),
    revokedCount: z.int().gte(-9007199254740991).lte(9007199254740991)
});

export const zV1NotificationsListNotificationsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        cursor: z.optional(z.string()),
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
        type: z.optional(z.enum(['banner', 'announcement'])),
        status: z.optional(z.enum(['read', 'unread'])),
        ids: z.optional(z.array(z.string()).max(100))
    }))
});

/**
 * Default Response
 */
export const zV1NotificationsListNotificationsResponse = z.object({
    data: z.array(zNotification),
    meta: zCursorPaginationMeta
});

export const zV1NotificationsMarkAsReadData = z.object({
    body: z.union([
        zMarkNotificationsRead,
        zMarkAllNotificationsRead,
        zMarkAllNotificationsSeen
    ]),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1NotificationsMarkAsReadResponse = z.object({
    status: z.enum(['success'])
});

export const zV1NotificationsGetBadgeCountData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1NotificationsGetBadgeCountResponse = z.object({
    data: z.object({
        unseen: z.number(),
        unread: z.number()
    })
});

export const zV1NotificationsConnectionTokenData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1NotificationsConnectionTokenResponse = z.object({
    data: zNotificationConnectionTokenData
});

export const zV1NotificationsDirectoryConnectionTokenData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1NotificationsDirectoryConnectionTokenResponse = z.object({
    data: zDirectoryConnectionTokenData
});

export const zV1NotificationsListPreferencesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1NotificationsListPreferencesResponse = z.object({
    data: zResolvedNotificationPreferences
});

export const zV1NotificationsUpdatePreferencesData = z.object({
    body: z.object({
        data: zUpdateNotificationPreferences
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1NotificationsUpdatePreferencesResponse = z.object({
    data: zResolvedNotificationPreferences
});

export const zV1OrganizationsListPeopleData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        cursor: z.optional(z.string()),
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
        status: z.optional(z.array(z.enum([
            'active',
            'invited',
            'deactivated',
            'removed'
        ])).min(1).max(4)),
        role: z.optional(z.array(z.enum(['org_admin', 'member'])).min(1).max(2)),
        search: z.optional(z.string().min(1).max(256)),
        ids: z.optional(z.array(z.string().min(1)).min(1).max(50))
    }))
});

/**
 * Default Response
 */
export const zV1OrganizationsListPeopleResponse = z.object({
    data: z.array(zOrganizationPerson),
    meta: zCursorPaginationMeta
});

export const zV1OrganizationsListOrganizationSessionsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gt(0).lte(9007199254740991)).default(1),
        limit: z.optional(z.int().gte(1).lte(100)).default(20)
    }))
});

/**
 * Default Response
 */
export const zV1OrganizationsListOrganizationSessionsResponse = z.object({
    data: z.array(zOrganizationSessionListItem),
    meta: zOffsetPaginationMeta
});

export const zV1OrganizationsInvitePersonData = z.object({
    body: z.object({
        data: z.object({
            email: z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
            name: z.optional(z.string().min(1).max(128)),
            role: z.enum(['org_admin', 'member']),
            language: z.enum(['it', 'en']),
            quotaBytes: z.union([
                z.int().gt(0).lte(9007199254740991),
                z.null()
            ])
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1OrganizationsInvitePersonResponse = z.object({
    data: zOrganizationInvitation
});

export const zV1OrganizationsResendInvitationData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        inviteId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1OrganizationsResendInvitationResponse = z.union([
    z.object({
        status: z.literal('success')
    }).and(zInvitationSent),
    z.object({
        status: z.literal('requires_deactivation')
    }).and(zInvitationRequiresDeactivation)
]);

export const zV1OrganizationsRevokeInvitationData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        inviteId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1OrganizationsRevokeInvitationResponse = z.union([
    z.object({
        status: z.literal('success')
    }).and(zInvitationRevoked),
    z.object({
        status: z.literal('requires_deactivation')
    }).and(zInvitationRequiresDeactivation)
]);

export const zV1OrganizationsChangeInvitationEmailData = z.object({
    body: z.object({
        email: z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/)
    }),
    path: z.object({
        inviteId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1OrganizationsChangeInvitationEmailResponse = z.union([
    z.object({
        status: z.literal('success')
    }).and(zInvitationSent),
    z.object({
        status: z.literal('requires_deactivation')
    }).and(zInvitationRequiresDeactivation)
]);

export const zV1OrganizationsDeactivatePersonData = z.object({
    body: z.object({
        status: z.enum(['deactivated', 'active']),
        reason: z.optional(z.string().min(1).max(1024))
    }),
    path: z.object({
        userId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1OrganizationsDeactivatePersonResponse = z.object({
    status: z.enum(['success']),
    sessionsRevoked: z.optional(z.int().gte(0).lte(9007199254740991)),
    residualWindowSeconds: z.optional(z.int().gt(0).lte(9007199254740991)),
    channel: z.optional(z.enum(['closed', 'pending'])),
    channelWindowSeconds: z.optional(z.int().gt(0).lte(9007199254740991))
});

export const zV1OrganizationsRemovePersonData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        userId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1OrganizationsRemovePersonResponse = z.object({
    status: z.enum(['success']),
    sessionsRevoked: z.int().gte(0).lte(9007199254740991),
    residualWindowSeconds: z.int().gt(0).lte(9007199254740991),
    channel: z.enum(['closed', 'pending']),
    channelWindowSeconds: z.optional(z.int().gt(0).lte(9007199254740991))
});

export const zV1OrganizationsChangeRoleData = z.object({
    body: z.object({
        role: z.string().min(1).max(64)
    }),
    path: z.object({
        userId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1OrganizationsChangeRoleResponse = z.object({
    role: z.enum(['org_admin', 'member'])
});

export const zV1OrganizationsGetQuotaData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1OrganizationsGetQuotaResponse = z.object({
    data: zOrganizationQuota
});

export const zV1OrganizationsSetPersonQuotaData = z.object({
    body: z.object({
        quotaBytes: z.union([
            z.int().gte(0).lte(9007199254740991),
            z.null()
        ])
    }),
    path: z.object({
        userId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1OrganizationsSetPersonQuotaResponse = z.object({
    data: zPersonQuota
});

export const zV1OrganizationsGetVersionRetentionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1OrganizationsGetVersionRetentionResponse = z.object({
    data: zVersionRetention
});

export const zV1OrganizationsSetVersionRetentionData = z.object({
    body: z.object({
        keepVersions: z.union([
            z.int().gte(1).lte(1000),
            z.null()
        ]),
        keepDays: z.union([
            z.int().gte(1).lte(3650),
            z.null()
        ])
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1OrganizationsSetVersionRetentionResponse = z.object({
    data: zVersionRetention
});

export const zV1OrganizationsGetAssetData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        orgId: z.string().min(1),
        assetId: z.string().min(1),
        variant: z.enum([
            'original',
            'thumbnail',
            'small',
            'medium',
            'large'
        ])
    }),
    query: z.optional(z.never())
});

export const zV1PoliciesListPoliciesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1PoliciesListPoliciesResponse = z.object({
    data: z.array(zPolicySetting)
});

export const zV1PoliciesSetPolicyData = z.object({
    body: z.object({
        value: z.unknown()
    }),
    path: z.object({
        key: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1PoliciesSetPolicyResponse = z.object({
    data: zPolicySetting
});

export const zV1GroupsListData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        cursor: z.optional(z.string()),
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
        q: z.optional(z.string().min(1).max(100)),
        member: z.optional(z.string())
    }))
});

/**
 * Default Response
 */
export const zV1GroupsListResponse = z.object({
    data: z.array(zGroup),
    meta: zCursorPaginationMeta
});

export const zV1GroupsCreateData = z.object({
    body: z.object({
        data: z.object({
            name: z.string().min(1).max(100),
            visibility: z.optional(z.enum(['public', 'private']))
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1GroupsCreateResponse = z.object({
    data: zGroup
});

export const zV1GroupsDeleteData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        groupId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1GroupsDeleteResponse = z.object({
    status: z.enum(['success'])
});

export const zV1GroupsGetData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        groupId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1GroupsGetResponse = z.object({
    data: zGroupDetail
});

export const zV1GroupsUpdateData = z.object({
    body: z.object({
        data: z.object({
            name: z.optional(z.string().min(1).max(100)),
            visibility: z.optional(z.enum(['public', 'private']))
        })
    }),
    path: z.object({
        groupId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1GroupsUpdateResponse = z.object({
    data: zGroup
});

export const zV1GroupsListMembersData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        groupId: z.string()
    }),
    query: z.optional(z.object({
        cursor: z.optional(z.string()),
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
        q: z.optional(z.string().min(1).max(100))
    }))
});

/**
 * Default Response
 */
export const zV1GroupsListMembersResponse = z.object({
    data: z.array(zUserSearchResult),
    meta: zCursorPaginationMeta
});

export const zV1GroupsAddMembersData = z.object({
    body: z.object({
        data: z.object({
            userIds: z.array(z.string()).min(1).max(100)
        })
    }),
    path: z.object({
        groupId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1GroupsAddMembersResponse = z.object({
    data: zGroup
});

export const zV1GroupsListCandidatesData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        groupId: z.string()
    }),
    query: z.optional(z.object({
        cursor: z.optional(z.string()),
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
        q: z.optional(z.string().min(1).max(100))
    }))
});

/**
 * Default Response
 */
export const zV1GroupsListCandidatesResponse = z.object({
    data: z.array(zGroupCandidate),
    meta: zCursorPaginationMeta
});

export const zV1GroupsRemoveMemberData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        groupId: z.string(),
        userId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1GroupsRemoveMemberResponse = z.object({
    status: z.enum(['success'])
});

export const zV1ShareNotificationsCreateData = z.object({
    body: z.object({
        data: z.object({
            nodeId: z.string(),
            userIds: z.optional(z.array(z.string()).max(20)).default([]),
            groupIds: z.optional(z.array(z.string()).max(5)).default([]),
            role: z.enum(['viewer', 'editor']),
            message: z.optional(z.string().max(1000))
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1ShareNotificationsCreateResponse = z.object({
    data: z.object({
        notified: z.number()
    })
});

export const zV1BackofficeListUsersData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        page: z.optional(z.int().gt(0).lte(9007199254740991)).default(1),
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
        organizationId: z.string(),
        ids: z.optional(z.array(z.string()).min(1).max(100)),
        search: z.optional(z.string().min(1)),
        status: z.optional(z.array(z.enum([
            'active',
            'banned',
            'deleted'
        ])).min(1).max(3)),
        banned: z.optional(z.string()),
        emailVerified: z.optional(z.string()),
        createdAtFrom: z.optional(zInstant),
        createdAtTo: z.optional(zInstant),
        sortBy: z.optional(z.enum(['createdAt', 'name'])),
        sortDirection: z.optional(z.enum(['asc', 'desc']))
    })
});

/**
 * Default Response
 */
export const zV1BackofficeListUsersResponse = z.object({
    data: z.array(zAdminUserListItem),
    meta: zOffsetPaginationMeta
});

export const zV1BackofficeExportUsersData = z.object({
    body: z.object({
        format: z.enum(['csv', 'xlsx']),
        mode: z.optional(z.enum([
            'auto',
            'sync',
            'async'
        ])),
        filters: z.optional(z.object({
            ids: z.optional(z.union([
                z.array(z.string()).min(1).max(100),
                z.null()
            ])),
            search: z.optional(z.union([
                z.string().min(1),
                z.null()
            ])),
            status: z.optional(z.union([
                z.array(z.enum([
                    'active',
                    'banned',
                    'deleted'
                ])).min(1).max(3),
                z.null()
            ])),
            banned: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            emailVerified: z.optional(z.union([
                z.boolean(),
                z.null()
            ])),
            createdAt: z.optional(zInstantRange)
        })),
        sort: z.optional(z.object({
            by: z.optional(z.enum(['createdAt', 'name'])),
            direction: z.optional(z.enum(['asc', 'desc']))
        })).default({ by: 'createdAt', direction: 'desc' })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

export const zV1BackofficeExportUsersResponse = z.union([
    z.string(),
    z.object({
        data: z.object({
            id: z.string(),
            dataset: z.string(),
            format: z.enum(['csv', 'xlsx']),
            status: z.enum(['pending']),
            rowCount: z.union([
                z.int().gte(0).lte(9007199254740991),
                z.null()
            ]),
            fileName: z.string(),
            expiresAt: zInstantOutput
        })
    })
]);

export const zV1BackofficeExportsIdData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1BackofficeExportsIdResponse = z.object({
    data: z.object({
        id: z.string(),
        dataset: z.string(),
        format: z.enum(['csv', 'xlsx']),
        status: z.enum([
            'pending',
            'running',
            'completed',
            'failed',
            'expired'
        ]),
        rowCount: z.union([
            z.int().gte(0).lte(9007199254740991),
            z.null()
        ]),
        fileName: z.string(),
        mimeType: z.string(),
        errorMessage: z.union([
            z.string(),
            z.null()
        ]),
        createdAt: zInstantOutput,
        startedAt: z.union([
            z.string(),
            z.null()
        ]),
        completedAt: z.union([
            z.string(),
            z.null()
        ]),
        expiresAt: zInstantOutput,
        downloadUrl: z.union([
            z.url(),
            z.null()
        ])
    })
});

export const zV1BackofficeGetUserNotificationPreferencesData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        userId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1BackofficeGetUserNotificationPreferencesResponse = z.object({
    data: zResolvedNotificationPreferences
});

export const zV1BackofficeGetUserPushRegistrationsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        userId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1BackofficeGetUserPushRegistrationsResponse = z.object({
    data: zAdminUserPushRegistrations
});

export const zV1BackofficeGetUserSessionsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        userId: z.string()
    }),
    query: z.optional(z.object({
        page: z.optional(z.int().gt(0).lte(9007199254740991)).default(1),
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
        status: z.optional(z.array(z.enum([
            'active',
            'revoked',
            'expired'
        ])).min(1).max(3))
    }))
});

/**
 * Default Response
 */
export const zV1BackofficeGetUserSessionsResponse = z.object({
    data: z.array(zAdminUserSessionItem),
    meta: zOffsetPaginationMeta
});

export const zV1BackofficeListSentNotificationsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        page: z.optional(z.int().gt(0).lte(9007199254740991)).default(1),
        limit: z.optional(z.int().gte(1).lte(100)).default(20)
    }))
});

/**
 * Default Response
 */
export const zV1BackofficeListSentNotificationsResponse = z.object({
    data: z.array(zNotificationBroadcast),
    meta: zOffsetPaginationMeta
});

export const zV1BackofficeSendNotificationData = z.object({
    body: z.object({
        data: z.object({
            type: zAdminBroadcastableNotificationType,
            title: z.string().min(1).max(256),
            body: z.string().min(1).max(4000),
            target: z.union([
                z.object({
                    type: z.enum(['all'])
                }),
                z.object({
                    type: z.enum(['selected']),
                    userIds: z.array(z.string()).min(1).max(10000)
                })
            ]),
            channels: z.object({
                push: z.boolean()
            })
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1BackofficeSendNotificationResponse = z.object({
    data: zNotificationBroadcast
});

export const zV1BackofficeGetNotificationRecipientsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        broadcastId: z.string()
    }),
    query: z.optional(z.object({
        cursor: z.optional(z.string()),
        limit: z.optional(z.int().gte(1).lte(100)).default(20)
    }))
});

/**
 * Default Response
 */
export const zV1BackofficeGetNotificationRecipientsResponse = z.object({
    data: z.array(zBroadcastRecipient),
    meta: zCursorPaginationMeta
});

export const zV1BackofficeListOrganizationsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        cursor: z.optional(z.string()),
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
        status: z.optional(z.array(z.enum([
            'pending',
            'identity_ready',
            'storage_ready',
            'admin_invited',
            'ready',
            'failed',
            'suspended',
            'purging',
            'purged'
        ])).min(1)),
        name: z.optional(z.string().min(1).max(256)),
        sortBy: z.optional(z.enum(['createdAt', 'usageBytes'])),
        sortDirection: z.optional(z.enum(['asc', 'desc']))
    }))
});

/**
 * Default Response
 */
export const zV1BackofficeListOrganizationsResponse = z.object({
    data: z.array(zOrganizationListItem),
    meta: zCursorPaginationMeta
});

export const zV1BackofficeCreateOrganizationData = z.object({
    body: z.object({
        data: z.object({
            slug: z.string().min(3).max(64).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
            name: z.string().min(1).max(256),
            adminEmail: z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
            language: z.enum(['it', 'en']),
            quotaBytes: z.union([
                z.int().gt(0).lte(9007199254740991),
                z.null()
            ])
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1BackofficeCreateOrganizationResponse = z.object({
    data: zOrganization
});

export const zV1BackofficeCheckSlugAvailabilityData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        slug: z.string().min(3).max(64).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/)
    })
});

/**
 * Default Response
 */
export const zV1BackofficeCheckSlugAvailabilityResponse = z.object({
    status: z.enum(['success']),
    available: z.boolean()
});

export const zV1BackofficePurgeOrganizationData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1BackofficePurgeOrganizationResponse = z.union([
    z.object({
        status: z.literal('queued')
    }).and(zPurgeOrganizationQueued),
    z.object({
        status: z.literal('already_in_progress')
    }).and(zPurgeOrganizationAlreadyInProgress),
    z.object({
        status: z.literal('already_purged')
    }).and(zPurgeOrganizationAlreadyPurged)
]);

export const zV1BackofficeGetOrganizationData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1BackofficeGetOrganizationResponse = z.object({
    data: zOrganizationDetail
});

export const zV1BackofficeRetryProvisioningData = z.object({
    body: z.object({
        data: z.optional(z.object({
            adminEmail: z.optional(z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/)),
            language: z.optional(z.enum(['it', 'en']))
        })).default({})
    }),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1BackofficeRetryProvisioningResponse = z.union([
    z.object({
        status: z.literal('queued')
    }).and(zRetryProvisioningQueued),
    z.object({
        status: z.literal('already_in_progress')
    }).and(zRetryProvisioningAlreadyInProgress),
    z.object({
        status: z.literal('requires_admin_email')
    }).and(zRetryProvisioningRequiresAdminEmail)
]);

export const zV1BackofficeSuspendOrganizationData = z.object({
    body: z.object({
        status: z.enum(['suspended', 'active']),
        reason: z.optional(z.string().min(1).max(1024))
    }),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1BackofficeSuspendOrganizationResponse = z.object({
    data: zOrganization
});

export const zV1BackofficeSetOrganizationQuotaData = z.object({
    body: z.object({
        quotaBytes: z.union([
            z.int().gte(0).lte(9007199254740991),
            z.null()
        ])
    }),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1BackofficeSetOrganizationQuotaResponse = z.object({
    data: zOrganizationDetail
});

export const zV1BackofficeGetFirstAdminInvitationData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1BackofficeGetFirstAdminInvitationResponse = z.object({
    data: z.union([
        z.object({
            email: z.string(),
            status: z.enum([
                'pending',
                'accepted',
                'expired',
                'revoked'
            ]),
            expiresAt: zInstantOutput,
            createdAt: zInstantOutput,
            resendCount: z.int().gte(-9007199254740991).lte(9007199254740991)
        }),
        z.null()
    ])
});

export const zV1BackofficeResendFirstAdminInvitationData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1BackofficeResendFirstAdminInvitationResponse = z.union([
    z.object({
        status: z.literal('success')
    }).and(zInvitationSent),
    z.object({
        status: z.literal('requires_deactivation')
    }).and(zInvitationRequiresDeactivation)
]);

export const zV1BackofficeInviteOrganizationOwnerData = z.object({
    body: z.object({
        data: z.object({
            email: z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
            language: z.enum(['it', 'en'])
        })
    }),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1BackofficeInviteOrganizationOwnerResponse = z.object({
    data: zOrganizationInvitation
});

export const zV1BackofficeListOrganizationPeopleData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string()
    }),
    query: z.optional(z.object({
        cursor: z.optional(z.string()),
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
        status: z.optional(z.array(z.enum([
            'active',
            'invited',
            'deactivated',
            'removed'
        ])).min(1).max(4)),
        role: z.optional(z.array(z.enum(['org_admin', 'member'])).min(1).max(2)),
        search: z.optional(z.string().min(1).max(256)),
        owner: z.optional(z.string())
    }))
});

/**
 * Default Response
 */
export const zV1BackofficeListOrganizationPeopleResponse = z.object({
    data: z.array(zOrganizationPerson),
    meta: zCursorPaginationMeta
});

export const zV1BackofficeRevokeOrganizationOwnershipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string(),
        userId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1BackofficeRevokeOrganizationOwnershipResponse = z.object({
    data: z.object({
        userId: z.string(),
        isOwner: z.literal(false),
        remainingOwners: z.int().gt(0).lte(9007199254740991)
    })
});

export const zV1BackofficeGrantOrganizationOwnershipData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string(),
        userId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1BackofficeGrantOrganizationOwnershipResponse = z.object({
    data: z.object({
        userId: z.string(),
        isOwner: z.literal(true),
        previousRole: z.nullable(z.enum(['org_admin', 'member']))
    })
});

export const zV1BackofficeRemoveOrganizationOwnerData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        id: z.string(),
        userId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1BackofficeRemoveOrganizationOwnerResponse = z.object({
    status: z.enum(['success']),
    sessionsRevoked: z.int().gte(0).lte(9007199254740991),
    residualWindowSeconds: z.int().gt(0).lte(9007199254740991),
    channel: z.enum(['closed', 'pending']),
    channelWindowSeconds: z.optional(z.int().gt(0).lte(9007199254740991))
});

export const zV1BackofficeListAuditEventsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        cursor: z.optional(z.string()),
        limit: z.optional(z.int().gte(1).lte(100)).default(20),
        from: z.optional(zInstant),
        to: z.optional(zInstant),
        actions: z.optional(z.array(z.enum([
            'organization.created',
            'organization.suspended',
            'organization.reactivated',
            'organization.storage_destroyed',
            'user.invited',
            'user.invite_resent',
            'notification_broadcast.send',
            'operator.invited',
            'operator.invitation_resent',
            'operator.invitation_email_changed',
            'operator.invitation_revoked',
            'operator.activated',
            'operator.deactivated',
            'operator.reactivated',
            'operator.removed'
        ])).min(1)),
        organizationId: z.optional(z.string())
    }))
});

/**
 * Default Response
 */
export const zV1BackofficeListAuditEventsResponse = z.object({
    data: z.array(zOperatorAuditEvent),
    meta: z.object({
        nextCursor: z.union([
            z.string(),
            z.null()
        ])
    })
});

export const zV1BackofficeListOperatorsData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        status: z.optional(z.array(z.enum([
            'invited',
            'expired',
            'active',
            'disabled'
        ])).min(1).max(4)),
        search: z.optional(z.string().min(1).max(256))
    }))
});

/**
 * Default Response
 */
export const zV1BackofficeListOperatorsResponse = z.object({
    data: z.array(zBackofficeOperator),
    meta: z.object({
        total: z.number()
    })
});

export const zV1BackofficeInviteOperatorData = z.object({
    body: z.object({
        data: z.object({
            email: z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
            name: z.optional(z.string().min(1).max(128)),
            language: z.enum(['it', 'en'])
        })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1BackofficeInviteOperatorResponse = z.object({
    data: zBackofficeOperator
});

export const zV1BackofficeResendOperatorInvitationData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        invitationId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1BackofficeResendOperatorInvitationResponse = z.object({
    data: zBackofficeOperator
});

export const zV1BackofficeRevokeOperatorInvitationData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        invitationId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1BackofficeRevokeOperatorInvitationResponse = z.object({
    status: z.enum(['success'])
});

export const zV1BackofficeChangeOperatorInvitationEmailData = z.object({
    body: z.object({
        email: z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/)
    }),
    path: z.object({
        invitationId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1BackofficeChangeOperatorInvitationEmailResponse = z.object({
    data: zBackofficeOperator
});

export const zV1BackofficeReactivateOperatorData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        operatorId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1BackofficeReactivateOperatorResponse = z.object({
    data: zBackofficeOperator
});

export const zV1BackofficeDeactivateOperatorData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        operatorId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1BackofficeDeactivateOperatorResponse = z.object({
    data: zBackofficeOperator
});

export const zV1BackofficeRemoveOperatorData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        operatorId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1BackofficeRemoveOperatorResponse = z.object({
    status: z.enum(['success'])
});

export const zV1BackofficeGetClientPolicyData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1BackofficeGetClientPolicyResponse = z.object({
    data: zBackofficeClientPolicy
});

export const zV1BackofficeSetClientPlatformVersionsData = z.object({
    body: z.object({
        minimumVersion: z.union([
            z.string().max(64),
            z.null()
        ]),
        latestVersion: z.union([
            z.string().max(64),
            z.null()
        ])
    }),
    path: z.object({
        platform: z.enum([
            'ios',
            'android',
            'macos',
            'windows'
        ])
    }),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1BackofficeSetClientPlatformVersionsResponse = z.object({
    data: zBackofficeClientPolicy
});

export const zV1BackofficeSetMaintenanceData = z.object({
    body: z.object({
        active: z.boolean(),
        message: z.union([
            z.string().min(1).max(500),
            z.null()
        ]),
        until: z.union([
            z.string(),
            z.null()
        ])
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1BackofficeSetMaintenanceResponse = z.object({
    data: zBackofficeClientPolicy
});

export const zV1BackofficeAuthStartOidcLoginData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        locale: z.optional(z.enum(['en', 'it']))
    }))
});

/**
 * Default Response
 */
export const zV1BackofficeAuthStartOidcLoginResponse = z.object({
    data: z.object({
        authorizationUrl: z.string()
    })
});

export const zV1BackofficeAuthOidcCallbackData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        code: z.optional(z.string()),
        state: z.optional(z.string()),
        error: z.optional(z.string()),
        error_description: z.optional(z.string())
    }))
});

export const zV1BackofficeAuthSignOutData = z.object({
    body: z.object({
        token: z.optional(z.string().min(1))
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1BackofficeAuthSignOutResponse = z.object({
    status: z.enum(['success'])
});

export const zV1BackofficeAuthGetSessionData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1BackofficeAuthGetSessionResponse = z.object({
    sessionType: z.enum(['anonymous', 'authenticated']),
    csrfToken: z.union([
        z.string(),
        z.null()
    ]),
    session: z.union([
        z.object({
            expiresAt: zInstantOutput,
            lastActivityAt: zInstantOutput,
            creationSource: z.string()
        }),
        z.null()
    ]),
    user: z.union([
        z.object({
            id: z.string(),
            name: z.string(),
            email: z.union([
                z.string(),
                z.null()
            ])
        }),
        z.null()
    ])
});

export const zV1BackofficeAuthOidcLogoutData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1BackofficeAuthOidcLogoutResponse = z.object({
    status: z.enum(['success'])
});

export const zV1BackofficeValidateOperatorInvitationData = z.object({
    body: z.object({
        code: z.string().min(1).max(512)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1BackofficeValidateOperatorInvitationResponse = z.object({
    data: z.object({
        email: z.string(),
        language: z.string(),
        passwordPolicy: zPasswordPolicy
    })
});

export const zV1BackofficeActivateOperatorInvitationData = z.object({
    body: z.object({
        code: z.string().min(1).max(512),
        password: z.string().min(1).max(256),
        firstName: z.string().min(1).max(128),
        lastName: z.string().min(1).max(128)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zV1BackofficeActivateOperatorInvitationResponse = z.object({
    status: z.enum(['success']),
    email: z.string(),
    signedIn: z.boolean()
});

export const zHealthCheckData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zHealthCheckResponse = z.enum(['Healthy']);

export const zHealthCheckLiveData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zHealthCheckLiveResponse = z.enum(['Healthy']);

export const zHealthCheckServicesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Default Response
 */
export const zHealthCheckServicesResponse = z.object({
    isHealthy: z.boolean(),
    services: z.record(z.string(), zServiceHealth),
    version: z.string()
});

export const zV1DirectoryListChangesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        cursor: z.string(),
        limit: z.optional(z.int().gte(1).lte(1000)).default(500)
    })
});

/**
 * One page of changes.
 */
export const zV1DirectoryListChangesResponse = z.object({
    data: z.object({
        entries: z.array(z.union([z.object({
                type: z.literal('upsert')
            }).and(zChangeUpsert), z.object({
                type: z.literal('removed')
            }).and(zChangeRemoved)])),
        cursor: z.string(),
        hasMore: z.boolean()
    })
});

export const zV1DirectoryGetChangesHeadData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * The cursor of the newest change.
 */
export const zV1DirectoryGetChangesHeadResponse = z.object({
    data: z.object({
        cursor: z.string()
    })
});

export const zV1DirectoryCopyNodesData = z.object({
    body: z.object({
        parentId: z.string(),
        nodeIds: z.array(z.string()).min(1).max(50)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'idempotency-key': z.optional(z.string().min(1).max(255)),
        'X-Batch-Id': z.optional(z.string())
    }))
});

/**
 * `{ "items": [...] }`, one outcome per file of a copy call, in the order
 * sent.
 */
export const zV1DirectoryCopyNodesResponse = z.object({
    items: z.array(z.union([z.object({
            status: z.literal('copied')
        }).and(zNodeCopied), z.object({
            status: z.literal('refused')
        }).and(zNodeCopyRefused)]))
});

export const zV1DirectoryAuthorizeDownloadsData = z.object({
    body: z.object({
        items: z.array(z.object({
            nodeId: z.string(),
            versionId: z.optional(z.union([
                z.string(),
                z.null()
            ]))
        })).min(1).max(50)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Batch-Id': z.optional(z.string())
    }))
});

/**
 * `{ "items": [...] }`, in the order asked.
 */
export const zV1DirectoryAuthorizeDownloadsResponse = z.object({
    items: z.array(z.union([z.object({
            status: z.literal('authorized')
        }).and(zDownloadAuthorized), z.object({
            status: z.literal('refused')
        }).and(zDownloadRefused)]))
});

export const zV1DirectoryCreateDownloadPlanData = z.object({
    body: z.object({
        nodeIds: z.array(z.string()).min(1).max(1000)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * The plan, or `too_large`.
 */
export const zV1DirectoryCreateDownloadPlanResponse = z.union([
    z.object({
        status: z.literal('success')
    }).and(zDownloadPlanReady),
    z.object({
        status: z.literal('too_large')
    }).and(zDownloadPlanTooLarge)
]);

export const zV1DirectoryListFavoritesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        sortBy: z.optional(z.enum([
            'name',
            'updatedAt',
            'size'
        ])),
        sortDirection: z.optional(z.enum(['asc', 'desc'])),
        foldersFirst: z.optional(z.boolean()).default(true),
        categories: z.optional(z.array(z.enum([
            'folder',
            'document',
            'image',
            'spreadsheet',
            'archive',
            'video',
            'audio',
            'presentation',
            'other'
        ])).min(1).max(9)),
        people: z.optional(z.array(z.string().min(1)).min(1).max(50)),
        cursor: z.optional(z.string()),
        limit: z.optional(z.int().gte(1).lte(100)).default(50)
    }))
});

/**
 * One page of favorites.
 */
export const zV1DirectoryListFavoritesResponse = z.object({
    data: z.array(zFavoriteRecord),
    meta: z.object({
        nextCursor: z.union([
            z.string(),
            z.null()
        ])
    })
});

export const zV1DirectoryAddFavoritesData = z.object({
    body: z.object({
        nodeIds: z.array(z.string()).max(100)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * `FavoritesResultSchema200`.
 */
export const zV1DirectoryAddFavoritesResponse = z.object({
    results: z.array(zFavoriteResult)
});

export const zV1DirectoryRemoveFavoritesData = z.object({
    body: z.object({
        nodeIds: z.array(z.string()).max(100)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * `FavoritesResultSchema200`.
 */
export const zV1DirectoryRemoveFavoritesResponse = z.object({
    results: z.array(zFavoriteResult)
});

export const zV1DirectoryOpenUploadData = z.object({
    body: z.object({
        parentId: z.string(),
        name: z.string(),
        sizeInBytes: z.int().gte(0).lte(9007199254740991),
        contentType: z.optional(z.string()),
        originalModifiedAt: z.optional(z.iso.datetime()),
        onNameConflict: z.optional(zOnNameConflict),
        expectedVersion: z.optional(z.int().gte(0).lte(9007199254740991)),
        checksum: z.optional(z.string().length(44))
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'idempotency-key': z.optional(z.string().min(1).max(255)),
        'X-Batch-Id': z.optional(z.string())
    }))
});

/**
 * The file, and how to send it.
 */
export const zV1DirectoryOpenUploadResponse = z.union([
    z.object({
        strategy: z.literal('single')
    }).and(zOpenUploadSingle),
    z.object({
        strategy: z.literal('multipart')
    }).and(zOpenUploadMultipart)
]);

export const zV1DirectoryOpenMultipartData = z.object({
    body: z.object({
        contentType: z.optional(z.string())
    }),
    path: z.object({
        nodeId: z.string()
    }),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'idempotency-key': z.optional(z.string().min(1).max(255))
    }))
});

/**
 * The upload, and the first batch of part links.
 */
export const zV1DirectoryOpenMultipartResponse = z.object({
    status: z.enum(['success']),
    uploadId: z.string(),
    partSize: z.number(),
    partCount: z.number(),
    parts: z.array(zSignedPart),
    nextPartNumber: z.union([
        z.number(),
        z.null()
    ]),
    resumeExpiresAt: z.string(),
    expiresInSeconds: z.number()
});

export const zV1DirectoryCompleteUploadData = z.object({
    body: z.object({
        expectedVersion: z.optional(z.int().gte(0).lte(9007199254740991)),
        md5: z.optional(z.string().length(24))
    }),
    path: z.object({
        nodeId: z.string()
    }),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'idempotency-key': z.optional(z.string().min(1).max(255)),
        'X-Batch-Id': z.optional(z.string())
    }))
});

/**
 * The file, now live.
 */
export const zV1DirectoryCompleteUploadResponse = z.object({
    status: z.enum(['success']),
    node: zNode
});

export const zV1DirectoryCreateFolderData = z.object({
    body: z.object({
        parentId: z.string(),
        name: z.string(),
        onNameConflict: z.optional(zFolderNameConflict)
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'idempotency-key': z.optional(z.string().min(1).max(255))
    }))
});

export const zV1DirectoryCreateFolderResponse = z.union([
    z.object({
        data: zNode,
        meta: z.object({
            created: z.boolean(),
            requestedName: z.union([
                z.string(),
                z.null()
            ])
        })
    }),
    z.object({
        data: zNode,
        meta: z.object({
            created: z.boolean(),
            requestedName: z.union([
                z.string(),
                z.null()
            ])
        })
    })
]);

export const zV1DirectoryListFolderUploadsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        nodeId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * What a folder answers about everybody else's transfers into it.
 */
export const zV1DirectoryListFolderUploadsResponse = z.object({
    data: z.array(zFolderUpload)
});

export const zV1DirectoryGetNodesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        ids: z.array(z.string().min(1)).min(1).max(100)
    })
});

/**
 * The visible nodes, in the order they were asked for.
 */
export const zV1DirectoryGetNodesResponse = z.object({
    data: z.array(zNodeWithRole)
});

export const zV1DirectoryGetNodeData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        nodeId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * The answer a details panel is drawn from.
 */
export const zV1DirectoryGetNodeResponse = z.object({
    data: zNodeDetail
});

export const zV1DirectoryRenameNodeData = z.object({
    body: z.object({
        name: z.string()
    }),
    path: z.object({
        nodeId: z.string()
    }),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'If-Match': z.optional(z.string()),
        'idempotency-key': z.optional(z.string().min(1).max(255))
    }))
});

/**
 * The node, under its new name.
 */
export const zV1DirectoryRenameNodeResponse = z.object({
    data: zNode
});

export const zV1DirectoryListAncestorsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        nodeId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * The breadcrumb, root first.
 */
export const zV1DirectoryListAncestorsResponse = z.object({
    data: z.array(zAncestor),
    meta: z.object({
        origin: z.union([
            zSharedOrigin,
            z.null()
        ])
    })
});

export const zV1DirectoryListChildrenData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        nodeId: z.string()
    }),
    query: z.optional(z.object({
        sortBy: z.optional(z.enum([
            'name',
            'updatedAt',
            'size',
            'lastViewed'
        ])),
        sortDirection: z.optional(z.enum(['asc', 'desc'])),
        foldersFirst: z.optional(z.boolean()).default(true),
        categories: z.optional(z.array(z.enum([
            'folder',
            'document',
            'image',
            'spreadsheet',
            'archive',
            'video',
            'audio',
            'presentation',
            'other'
        ])).min(1).max(9)),
        people: z.optional(z.array(z.string().min(1)).min(1).max(50)),
        cursor: z.optional(z.string()),
        limit: z.optional(z.int().gte(1).lte(100)).default(50)
    }))
});

/**
 * One page of the folder.
 */
export const zV1DirectoryListChildrenResponse = z.object({
    data: z.array(zListedNode),
    meta: z.object({
        nextCursor: z.union([
            z.string(),
            z.null()
        ]),
        parentRole: zNodeRole
    })
});

export const zV1DirectoryAuthorizeDownloadData = z.object({
    body: z.object({
        disposition: z.optional(z.union([
            zContentDisposition,
            z.null()
        ]))
    }),
    path: z.object({
        nodeId: z.string()
    }),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Batch-Id': z.optional(z.string())
    }))
});

/**
 * `AuthorizeDownloadResponseSchema200` — the authorization to download one
 * file.
 *
 * `url` **is** the credential. It carries a signature that works for whoever
 * holds it, for one GET on one key, until it expires — so it is never logged,
 * never cached in a shared place, and never included in a listing.
 */
export const zV1DirectoryAuthorizeDownloadResponse = z.object({
    status: z.enum(['success']),
    url: z.string(),
    fileName: z.string(),
    expiresInSeconds: z.number()
});

export const zV1DirectoryListGrantsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        nodeId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * The owner, the two lists and the counter a save sends back.
 */
export const zV1DirectoryListGrantsResponse = z.object({
    data: z.object({
        owner: z.union([
            zNodeOwner,
            z.null()
        ]),
        direct: z.array(zNodeAccess),
        inherited: z.array(zInheritedNodeAccess),
        sharingVersion: z.number()
    })
});

export const zV1DirectorySetGrantsData = z.object({
    body: z.object({
        sharingVersion: z.int().min(-2147483648, { error: 'Invalid value: Expected int32 to be >= -2147483648' }).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' }),
        access: z.array(z.object({
            subjectType: z.optional(zAccessSubjectType),
            subjectId: z.string(),
            role: zNodeRole
        })).max(500),
        notify: z.optional(z.boolean()).default(true)
    }),
    path: z.object({
        nodeId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * What changed, and the counter to save against next time.
 */
export const zV1DirectorySetGrantsResponse = z.object({
    data: z.object({
        sharingVersion: z.number(),
        added: z.number(),
        changed: z.number(),
        removed: z.number()
    })
});

export const zV1DirectoryPreviewMoveData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        nodeId: z.string()
    }),
    query: z.object({
        newParentId: z.string()
    })
});

/**
 * The two counts.
 */
export const zV1DirectoryPreviewMoveResponse = z.object({
    data: z.object({
        peopleGainingAccess: z.number(),
        peopleLosingAccess: z.number(),
        opensToOrganization: z.boolean()
    })
});

export const zV1DirectorySetOrgLinkData = z.object({
    body: z.object({
        role: z.union([
            zNodeRole,
            z.null()
        ])
    }),
    path: z.object({
        nodeId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * The setting as it is now in force.
 */
export const zV1DirectorySetOrgLinkResponse = z.object({
    data: zOrgLinkState
});

export const zV1DirectoryMoveNodeData = z.object({
    body: z.object({
        newParentId: z.string(),
        name: z.optional(z.union([
            z.string(),
            z.null()
        ]))
    }),
    path: z.object({
        nodeId: z.string()
    }),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'If-Match': z.optional(z.string()),
        'idempotency-key': z.optional(z.string().min(1).max(255))
    }))
});

/**
 * The node, in its new folder, and how many people it is newly visible to.
 */
export const zV1DirectoryMoveNodeResponse = z.object({
    data: zNode,
    meta: z.object({
        peopleGainingAccess: z.number(),
        peopleLosingAccess: z.number(),
        opensToOrganization: z.boolean()
    })
});

export const zV1DirectoryListVersionsData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        nodeId: z.string()
    }),
    query: z.optional(z.object({
        cursor: z.optional(z.string()),
        limit: z.optional(z.int().gte(1).lte(100)).default(20)
    }))
});

/**
 * `ListVersionsResponseSchema200`.
 */
export const zV1DirectoryListVersionsResponse = z.object({
    data: z.array(zNodeVersion),
    meta: zVersionsMeta
});

export const zV1DirectoryDeleteVersionData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        nodeId: z.string(),
        versionId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * `DeleteVersionResponseSchema200`.
 */
export const zV1DirectoryDeleteVersionResponse = z.object({
    status: z.enum(['success'])
});

export const zV1DirectoryAuthorizeVersionDownloadData = z.object({
    body: z.object({
        disposition: z.optional(z.union([
            zContentDisposition,
            z.null()
        ]))
    }),
    path: z.object({
        nodeId: z.string(),
        versionId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * `AuthorizeDownloadResponseSchema200` — the authorization to download one
 * file.
 *
 * `url` **is** the credential. It carries a signature that works for whoever
 * holds it, for one GET on one key, until it expires — so it is never logged,
 * never cached in a shared place, and never included in a listing.
 */
export const zV1DirectoryAuthorizeVersionDownloadResponse = z.object({
    status: z.enum(['success']),
    url: z.string(),
    fileName: z.string(),
    expiresInSeconds: z.number()
});

export const zV1DirectoryRestoreVersionData = z.object({
    body: z.object({
        expectedVersion: z.optional(z.int().gte(0).lte(9007199254740991))
    }),
    path: z.object({
        nodeId: z.string(),
        versionId: z.string()
    }),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'idempotency-key': z.optional(z.string().min(1).max(255)),
        'X-Batch-Id': z.optional(z.string())
    }))
});

/**
 * `RestoreVersionResponseSchema200` — the file as it now is, and the version
 * the restore created.
 */
export const zV1DirectoryRestoreVersionResponse = z.object({
    status: z.enum(['success']),
    node: zNode,
    version: zNodeVersion
});

export const zV1DirectoryListRecentData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        scope: z.optional(z.enum([
            'everything',
            'shared-with-me',
            'folder'
        ])),
        folderId: z.optional(z.string()),
        limit: z.optional(z.int().gte(1).lte(50)).default(50)
    }))
});

/**
 * The most recent files, newest content first.
 */
export const zV1DirectoryListRecentResponse = z.object({
    data: z.array(zRecentRow),
    meta: z.record(z.string(), z.unknown())
});

export const zV1DirectorySearchData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        q: z.string(),
        scope: z.optional(z.enum([
            'everything',
            'shared-with-me',
            'folder',
            'trash'
        ])),
        folderId: z.optional(z.string()),
        categories: z.optional(z.array(z.enum([
            'folder',
            'document',
            'image',
            'spreadsheet',
            'archive',
            'video',
            'audio',
            'presentation',
            'other'
        ])).min(1).max(9)),
        people: z.optional(z.array(z.string().min(1)).min(1).max(50)),
        cursor: z.optional(z.string()),
        limit: z.optional(z.int().gte(1).lte(50)).default(25)
    })
});

/**
 * The page of hits: each one a listing row, plus which accessible root it came
 * from and its path relative to that root (T32.4) — never a per-row permission
 * evaluation.
 *
 * **A [`ListedNode`] and three fields, so a search result is drawn by the same
 * card and the same row as a folder's contents.** This was deliberately
 * narrower — no `role`, no `childCount` — and the reason was a real one: both
 * listings pay one permission check per *parent* because every row on a
 * folder's page shares it, a search has no such parent, and the naive way to
 * give a hit a role is the per-row check OPSSTD-7602 forbids.
 *
 * **Neither field is obtained that way.** `search_roots` still pays the
 * permission once per **root**, and that role is the floor under every hit
 * attributed to it; the only thing that can raise it is a grant *inside* the
 * root, which the handler reads for the whole page in **one** statement over
 * the hits and their path segments — a set it had already collected to name
 * the breadcrumb. `childCount` is the same grouped statement both listings
 * issue, over the page's folders and skipped when there are none. The number
 * of statements per request is fixed and does not follow the number of rows,
 * which is the property that rule protects.
 *
 * `rootId`, `rootType` and `path` are held to the same rule: attributed from
 * data the route already resolved (`search_roots::attribute`), never from a
 * fresh check per hit.
 */
export const zV1DirectorySearchResponse = z.object({
    data: z.array(zSearchHit),
    meta: z.object({
        nextCursor: z.union([
            z.string(),
            z.null()
        ])
    })
});

export const zV1DirectoryListSharedWithMeData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        sortBy: z.optional(z.enum([
            'name',
            'updatedAt',
            'size',
            'lastViewed'
        ])),
        sortDirection: z.optional(z.enum(['asc', 'desc'])),
        foldersFirst: z.optional(z.boolean()).default(true),
        categories: z.optional(z.array(z.enum([
            'folder',
            'document',
            'image',
            'spreadsheet',
            'archive',
            'video',
            'audio',
            'presentation',
            'other'
        ])).min(1).max(9)),
        people: z.optional(z.array(z.string().min(1)).min(1).max(50)),
        cursor: z.optional(z.string()),
        limit: z.optional(z.int().gte(1).lte(100)).default(50)
    }))
});

/**
 * One page of roots.
 */
export const zV1DirectoryListSharedWithMeResponse = z.object({
    data: z.array(zSharedRoot),
    meta: z.object({
        nextCursor: z.union([
            z.string(),
            z.null()
        ])
    })
});

export const zV1DirectoryGetThumbnailsData = z.object({
    body: z.object({
        nodeIds: z.array(z.string()).min(1).max(100),
        failed: z.optional(z.array(z.object({
            nodeId: z.string(),
            storageVersionId: z.string()
        })).max(100)),
        uploads: z.optional(z.array(z.object({
            nodeId: z.string(),
            storageVersionId: z.string(),
            sizeInBytes: z.int().gte(1).lte(262144)
        })).max(100)),
        renderers: z.optional(z.array(z.enum([
            'image',
            'pdf',
            'office',
            'video',
            'text'
        ])).max(16))
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * `GetThumbnailsResponseSchema200`.
 */
export const zV1DirectoryGetThumbnailsResponse = z.object({
    data: z.array(zThumbnailItem)
});

export const zV1DirectoryListTrashData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.object({
        categories: z.optional(z.array(z.enum([
            'folder',
            'document',
            'image',
            'spreadsheet',
            'archive',
            'video',
            'audio',
            'presentation',
            'other'
        ])).min(1).max(9)),
        cursor: z.optional(z.string()),
        limit: z.optional(z.int().gte(1).lte(100)).default(50)
    }))
});

/**
 * `ListTrashResponseSchema200`.
 */
export const zV1DirectoryListTrashResponse = z.object({
    data: z.array(zTrashedNode),
    meta: zTrashMeta
});

export const zV1DirectoryTrashData = z.object({
    body: z.object({
        nodeIds: z.array(z.string())
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Batch-Id': z.optional(z.string()),
        'If-Match': z.optional(z.string()),
        'idempotency-key': z.optional(z.string().min(1).max(255))
    }))
});

/**
 * `TrashNodesResponseSchema200`.
 *
 * A status envelope and not `{ data, meta }`: the call can partly succeed,
 * so there is no one record to hand back, only the two lists the description
 * promises — see the handler.
 */
export const zV1DirectoryTrashResponse = z.object({
    status: z.enum(['success']),
    trashed: z.array(z.string()),
    refused: z.array(zTrashRefusal)
});

export const zV1DirectoryEmptyTrashData = z.object({
    body: z.object({
        expectedCount: z.coerce.bigint().min(BigInt('-9223372036854775808'), { error: 'Invalid value: Expected int64 to be >= -9223372036854775808' }).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * `EmptyTrashResponseSchema202`.
 */
export const zV1DirectoryEmptyTrashResponse = z.object({
    status: z.enum(['success']),
    accepted: z.array(z.string())
});

export const zV1DirectoryPreviewTrashEmptyingData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * `TrashEmptyingPreviewResponseSchema200`.
 */
export const zV1DirectoryPreviewTrashEmptyingResponse = z.object({
    purgeableCount: z.number(),
    purgeableBytes: z.number(),
    keptCount: z.number()
});

export const zV1DirectoryDeletePermanentlyData = z.object({
    body: z.object({
        nodeIds: z.array(z.string())
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'If-Match': z.optional(z.string()),
        'idempotency-key': z.optional(z.string().min(1).max(255))
    }))
});

/**
 * `DeletePermanentlyResponseSchema202`.
 */
export const zV1DirectoryDeletePermanentlyResponse = z.object({
    status: z.enum(['success']),
    accepted: z.array(z.string()),
    refused: z.array(zPurgeRefusal)
});

export const zV1DirectoryPreviewTrashData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.object({
        nodeIds: z.array(z.string().min(1)).min(1).max(100)
    })
});

/**
 * `PreviewTrashResponseSchema200`.
 */
export const zV1DirectoryPreviewTrashResponse = z.object({
    data: z.array(zTrashPreviewItem),
    refused: z.array(zTrashPreviewRefusal)
});

export const zV1DirectoryRestoreFromTrashData = z.object({
    body: z.object({
        nodeIds: z.array(z.string()),
        onNameConflict: z.optional(z.union([
            zRestoreNameConflict,
            z.null()
        ])),
        destinationId: z.optional(z.union([
            z.string(),
            z.null()
        ]))
    }),
    path: z.optional(z.never()),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'X-Batch-Id': z.optional(z.string()),
        'If-Match': z.optional(z.string()),
        'idempotency-key': z.optional(z.string().min(1).max(255))
    }))
});

/**
 * `RestoreFromTrashResponseSchema200`.
 */
export const zV1DirectoryRestoreFromTrashResponse = z.object({
    status: z.enum(['success']),
    restored: z.array(zRestoredNode),
    refused: z.array(zRestoreRefusal)
});

export const zV1DirectoryListUploadBatchesData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * `{ "data": [...] }`.
 */
export const zV1DirectoryListUploadBatchesResponse = z.object({
    data: z.array(zUploadBatch)
});

export const zV1DirectoryAbandonUploadBatchData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        batchId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * `{ status, abandoned, remaining }`.
 */
export const zV1DirectoryAbandonUploadBatchResponse = z.object({
    status: z.enum(['success']),
    abandoned: z.number(),
    remaining: z.number()
});

export const zV1DirectoryCompleteBatchFilesData = z.object({
    body: z.object({
        items: z.array(z.object({
            nodeId: z.string()
        })).min(1).max(50)
    }),
    path: z.object({
        batchId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * `{ "items": [...] }`, in the order sent.
 */
export const zV1DirectoryCompleteBatchFilesResponse = z.object({
    items: z.array(z.union([z.object({
            status: z.literal('completed')
        }).and(zBatchFileConfirmed), z.object({
            status: z.literal('refused')
        }).and(zBatchFileNotConfirmed)]))
});

export const zV1DirectoryAnnounceBatchFilesData = z.object({
    body: z.object({
        rootId: z.string(),
        onNameConflict: z.optional(zOnNameConflict),
        items: z.array(z.object({
            relativePath: z.string(),
            sizeInBytes: z.int().gte(0).lte(9007199254740991),
            contentType: z.optional(z.union([
                z.string(),
                z.null()
            ])),
            originalModifiedAt: z.optional(z.union([
                z.iso.datetime(),
                z.null()
            ]))
        })).min(1).max(50)
    }),
    path: z.object({
        batchId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * `{ "items": [...] }`, in the order sent.
 */
export const zV1DirectoryAnnounceBatchFilesResponse = z.object({
    items: z.array(z.union([
        z.object({
            status: z.literal('opened')
        }).and(zBatchFileOpened),
        z.object({
            status: z.literal('completed')
        }).and(zBatchFileCompleted),
        z.object({
            status: z.literal('conflict')
        }).and(zBatchFileConflict),
        z.object({
            status: z.literal('refused')
        }).and(zBatchFileRefused)
    ]))
});

export const zV1DirectoryListUploadsInProgressData = z.object({
    body: z.optional(z.never()),
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * Your own unfinished uploads, newest first.
 */
export const zV1DirectoryListUploadsInProgressResponse = z.object({
    data: z.array(zUploadInProgress)
});

export const zV1DirectoryAbandonUploadsData = z.object({
    body: zAbandonUploadsPayload,
    path: z.optional(z.never()),
    query: z.optional(z.never())
});

/**
 * `AbandonUploadsResponseSchema200`.
 */
export const zV1DirectoryAbandonUploadsResponse = z.object({
    status: z.enum(['success']),
    abandoned: z.array(z.string())
});

export const zV1DirectoryIssuePartUrlsData = z.object({
    body: z.object({
        fromPartNumber: z.optional(z.int().gte(1).lte(9007199254740991)),
        partNumbers: z.optional(z.array(z.int().gte(1).lte(9007199254740991)).max(100))
    }),
    path: z.object({
        uploadId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Links for the parts still missing.
 */
export const zV1DirectoryIssuePartUrlsResponse = z.object({
    status: z.enum(['success']),
    parts: z.array(zSignedPart),
    nextPartNumber: z.union([
        z.number(),
        z.null()
    ]),
    expiresInSeconds: z.number()
});

export const zV1DirectoryConfirmPartData = z.object({
    body: z.object({
        etag: z.string(),
        sizeInBytes: z.int().gte(0).lte(9007199254740991)
    }),
    path: z.object({
        uploadId: z.string(),
        partNumber: z.int().gte(1).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
    }),
    query: z.optional(z.never())
});

/**
 * How far the upload has got.
 */
export const zV1DirectoryConfirmPartResponse = z.object({
    status: z.enum(['success']),
    confirmedParts: z.number(),
    partCount: z.number(),
    complete: z.boolean()
});

export const zV1DirectoryResumeUploadData = z.object({
    body: z.object({
        name: z.string(),
        originalModifiedAt: z.optional(z.iso.datetime()),
        sizeInBytes: z.int().gte(0).lte(9007199254740991)
    }),
    path: z.object({
        uploadId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * What is missing, and links for it.
 */
export const zV1DirectoryResumeUploadResponse = z.object({
    status: z.enum(['success']),
    partSize: z.number(),
    partCount: z.number(),
    confirmedParts: z.number(),
    parts: z.array(zSignedPart),
    nextPartNumber: z.union([
        z.number(),
        z.null()
    ]),
    resumeExpiresAt: z.string(),
    expiresInSeconds: z.number()
});

export const zV1PublicLinksGetLinkData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        token: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * The link, or the fact that it is locked.
 */
export const zV1PublicLinksGetLinkResponse = z.object({
    locked: z.boolean(),
    link: z.optional(z.union([
        zPublicLinkDetail,
        z.null()
    ]))
});

export const zV1PublicLinksGetFileUrlData = z.object({
    body: z.object({
        disposition: zContentDisposition
    }),
    path: z.object({
        token: z.string(),
        nodeId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * The signed URL.
 */
export const zV1PublicLinksGetFileUrlResponse = z.object({
    url: z.string(),
    fileName: z.string(),
    expiresInSeconds: z.coerce.bigint().gte(BigInt(0)).max(BigInt('9223372036854775807'), { error: 'Invalid value: Expected int64 to be <= 9223372036854775807' })
});

export const zV1PublicLinksListFolderData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        token: z.string(),
        nodeId: z.string()
    }),
    query: z.optional(z.object({
        cursor: z.optional(z.string()),
        limit: z.optional(z.int().gte(1).lte(100)).default(50)
    }))
});

/**
 * One page of the folder.
 */
export const zV1PublicLinksListFolderResponse = z.object({
    data: z.array(zPublicListedNode),
    meta: zPublicListingMeta
});

export const zV1PublicLinksGetThumbnailsData = z.object({
    body: z.object({
        nodeIds: z.array(z.string()).min(1).max(100)
    }),
    path: z.object({
        token: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * One entry per file, in the order sent.
 */
export const zV1PublicLinksGetThumbnailsResponse = z.object({
    data: z.array(zPublicThumbnailItem)
});

export const zV1PublicLinksUnlockData = z.object({
    body: z.object({
        password: z.string().max(1024)
    }),
    path: z.object({
        token: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Unlocked; the cookie is set.
 */
export const zV1PublicLinksUnlockResponse = z.void();

export const zV1PublicLinksOpenUploadData = z.object({
    body: z.object({
        name: z.string(),
        senderName: z.string().min(1).max(100),
        sizeInBytes: z.int().gte(0).lte(9007199254740991),
        contentType: z.optional(z.string()),
        originalModifiedAt: z.optional(z.iso.datetime())
    }),
    path: z.object({
        token: z.string()
    }),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'idempotency-key': z.optional(z.string().min(1))
    }))
});

/**
 * The transfer just opened, and the first parts to send.
 */
export const zV1PublicLinksOpenUploadResponse = z.object({
    status: z.enum(['success']),
    uploadId: z.string(),
    partSize: z.number(),
    partCount: z.number(),
    parts: z.array(zSignedPart),
    nextPartNumber: z.union([
        z.number(),
        z.null()
    ]),
    expiresInSeconds: z.number()
});

export const zV1PublicLinksAbandonUploadData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        token: z.string(),
        uploadId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Nothing of the transfer is left.
 */
export const zV1PublicLinksAbandonUploadResponse = z.void();

export const zV1PublicLinksCompleteUploadData = z.object({
    body: z.optional(z.never()),
    path: z.object({
        token: z.string(),
        uploadId: z.string()
    }),
    query: z.optional(z.never()),
    headers: z.optional(z.object({
        'idempotency-key': z.optional(z.string().min(1))
    }))
});

/**
 * That the file arrived, and nothing else about it.
 */
export const zV1PublicLinksCompleteUploadResponse = z.object({
    status: z.enum(['success']),
    sizeInBytes: z.number()
});

export const zV1PublicLinksIssuePartUrlsData = z.object({
    body: z.object({
        fromPartNumber: z.optional(z.int().gte(1).lte(9007199254740991)),
        partNumbers: z.optional(z.array(z.int().gte(1).lte(9007199254740991)).max(100))
    }),
    path: z.object({
        token: z.string(),
        uploadId: z.string()
    }),
    query: z.optional(z.never())
});

/**
 * Links for the parts still missing.
 */
export const zV1PublicLinksIssuePartUrlsResponse = z.object({
    status: z.enum(['success']),
    parts: z.array(zSignedPart),
    nextPartNumber: z.union([
        z.number(),
        z.null()
    ]),
    expiresInSeconds: z.number()
});

export const zV1PublicLinksConfirmPartData = z.object({
    body: z.object({
        etag: z.string(),
        sizeInBytes: z.int().gte(0).lte(9007199254740991)
    }),
    path: z.object({
        token: z.string(),
        uploadId: z.string(),
        partNumber: z.int().gte(1).max(2147483647, { error: 'Invalid value: Expected int32 to be <= 2147483647' })
    }),
    query: z.optional(z.never())
});

/**
 * How far the transfer has got.
 */
export const zV1PublicLinksConfirmPartResponse = z.object({
    status: z.enum(['success']),
    confirmedParts: z.number(),
    partCount: z.number(),
    complete: z.boolean()
});
